/**
 * SEARCH-INLINE.LIQUID — V5.1 (FIX MONEDA multi-país)
 * =====================================================
 *
 * Cambios sobre V5:
 * - formatShopifyPrice ahora usa Intl.NumberFormat con la moneda real del país
 * - formatProductsForDisplay reformatea SIEMPRE desde price_num para evitar
 *   que el "€" hardcodeado del JSON externo se cuele en Chile/USA/UK/etc.
 * - buildSearchIndex hace lo mismo para groupHexIndex (bubbles de colores)
 * - Aplica conversión por window.YUXUS_RATE si el JSON viene en EUR base
 */

document.addEventListener("DOMContentLoaded", function(){

const IS_SPAIN = window.YUXUS_IS_SPAIN || false;

// FIX MONEDA: leer moneda/locale del país (vienen de Liquid → window)
const CURRENCY = window.YUXUS_CURRENCY || 'EUR';
const LOCALE = window.YUXUS_LOCALE || (IS_SPAIN ? 'es-ES' : 'en-US');
const COUNTRY = window.YUXUS_COUNTRY || (IS_SPAIN ? 'ES' : 'US');
const RATE = parseFloat(window.YUXUS_RATE) || 1.0;

// Monedas que no usan decimales (CLP, JPY, KRW, ISK, etc.)
const ZERO_DECIMAL_CURRENCIES = ['CLP', 'JPY', 'KRW', 'ISK', 'HUF', 'TWD', 'VND', 'IDR'];
const isZeroDecimal = ZERO_DECIMAL_CURRENCIES.indexOf(CURRENCY) !== -1;

// FIX i18n (CRO 14.2): textos por idioma de la tienda (| t, namespace yuxus_search), ya no por país (antes ES=español, resto=inglés).
var _YT = window.YUXUS_SEARCH_T || {};
var ROOT = window.YUXUS_SEARCH_ROOT || '';
const T = {
  searching: _YT.searching,
  searchingAlternatives: _YT.searchingAlternatives,
  noProducts: _YT.noProducts,
  noStock: _YT.noStock,
  suggestions: _YT.suggestions,
  error: _YT.error,
  soldOut: _YT.soldOut,
  comingSoon: _YT.comingSoon,
  summerSale: _YT.summerSale,
  midSeasonSale: _YT.midSeasonSale,
  resultsFor: _YT.resultsFor,
  mostSearched: _YT.mostSearched,
  newArrivals: _YT.newArrivals,
  hoodies: _YT.hoodies,
  pants: _YT.pants,
  accessories: _YT.accessories,
  viewAll: _YT.viewAll,
  usefulLinks: _YT.usefulLinks,
  shippingPolicy: _YT.shippingPolicy,
  returnsExchanges: _YT.returnsExchanges,
  stores: _YT.stores,
  colours: _YT.colours,
  newIn: 'NEW IN', bestsellers: 'BESTSELLERS'
};

// ============================================================
// HELPER: getScrollY tolerante a in-app browsers
// ============================================================
var _isInApp = document.documentElement.classList.contains('is-inapp-browser');
function _getScrollY() {
  if (_isInApp) return document.body.scrollTop || 0;
  return window.pageYOffset || document.documentElement.scrollTop;
}

// ============================================================
// SECCIÓN 0: NORMALIZACIÓN + FUZZY UTILITIES
// ============================================================

function normalizeText(str) {
  return (str || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[""''«»„‟‛‹›`´]/g, '')
    .replace(/["']/g, '')
    .replace(/[^\w\s-]/g, ' ')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

function levenshtein(a, b, maxDist) {
  if (a === b) return 0;
  var la = a.length, lb = b.length;
  if (la === 0) return lb;
  if (lb === 0) return la;
  if (Math.abs(la - lb) > maxDist) return maxDist + 1;

  var row = new Array(lb + 1);
  for (var j = 0; j <= lb; j++) row[j] = j;

  for (var i = 1; i <= la; i++) {
    var prev = i;
    var rowMin = maxDist + 1;
    for (var j2 = 1; j2 <= lb; j2++) {
      var cost = a.charCodeAt(i - 1) === b.charCodeAt(j2 - 1) ? 0 : 1;
      var val = Math.min(
        row[j2] + 1,
        prev + 1,
        row[j2 - 1] + cost
      );
      row[j2 - 1] = prev;
      prev = val;
      if (val < rowMin) rowMin = val;
    }
    row[lb] = prev;
    if (rowMin > maxDist) return maxDist + 1;
  }
  return row[lb];
}

function fuzzyThreshold(wordLen) {
  if (wordLen <= 4) return 0;
  if (wordLen <= 6) return 1;
  if (wordLen <= 9) return 2;
  return 3;
}

function fuzzyThresholdTitle(wordLen) {
  if (wordLen <= 3) return 0;
  if (wordLen <= 5) return 1;
  if (wordLen <= 8) return 2;
  return 3;
}

function fuzzyMatchWord(queryWord, targetWord) {
  if (!queryWord || !targetWord) return 0;
  
  var qn = normalizeText(queryWord);
  var tn = normalizeText(targetWord);
  
  if (qn.length < 2) return 0;
  
  if (qn === tn) return 100;
  if (tn.indexOf(qn) !== -1) return 90;
  if (qn.indexOf(tn) !== -1) return 80;
  if (tn.indexOf(qn) === 0) return 95;
  if (qn.indexOf(tn) === 0) return 75;
  
  var threshold = fuzzyThresholdTitle(qn.length);
  if (threshold > 0) {
    var dist = levenshtein(qn, tn, threshold);
    if (dist <= threshold) {
      return 70 - (dist * 15);
    }
    
    if (qn.length >= 4 && tn.length > qn.length) {
      var targetPrefix = tn.substring(0, qn.length + 1);
      var distPrefix = levenshtein(qn, targetPrefix, threshold);
      if (distPrefix <= threshold) {
        return 60 - (distPrefix * 10);
      }
    }
  }
  
  if (qn.length >= 4) {
    var qBigrams = [];
    for (var i = 0; i < qn.length - 1; i++) qBigrams.push(qn.substring(i, i + 2));
    var tBigrams = [];
    for (var j = 0; j < tn.length - 1; j++) tBigrams.push(tn.substring(j, j + 2));
    
    var matches = 0;
    var used = {};
    for (var k = 0; k < qBigrams.length; k++) {
      for (var l = 0; l < tBigrams.length; l++) {
        if (qBigrams[k] === tBigrams[l] && !used[l]) {
          matches++;
          used[l] = true;
          break;
        }
      }
    }
    var bigramScore = matches / Math.max(qBigrams.length, tBigrams.length);
    if (bigramScore >= 0.5) {
      return Math.round(30 + bigramScore * 25);
    }
  }
  
  return 0;
}

function bestFuzzyMatch(queryWord, wordsArray) {
  var best = 0;
  for (var i = 0; i < wordsArray.length; i++) {
    var s = fuzzyMatchWord(queryWord, wordsArray[i]);
    if (s > best) best = s;
    if (best >= 95) break;
  }
  return best;
}


// ============================================================
// SECCIÓN 1: SISTEMA DE DATOS
// ============================================================

const SEARCH_DATA_URL = 'https://cdn.shopify.com/s/files/1/0715/1822/4676/files/yuxus-search-data.json?v=1767946459';

let salesDataCache = null;
let salesDataPromise = null;
let salesDataLoaded = false;
let salesUnitsMap = null;

let allProductsCache = null;
let productsPromise = null;
let productsLoaded = false;

// Índice de búsqueda
// ------------------------------------------------------------
// DISPONIBILIDAD POR MERCADO (Markets)
// El indice se construye con /products.json y con el JSON estatico del CDN, y
// ninguno de los dos aplica los catalogos de Markets: un producto despublicado
// en Alemania desaparecia de la web pero seguia saliendo aqui. Liquid si los
// aplica, asi que pedimos la lista blanca de handles del mercado actual y
// filtramos el dataset con ella. Si la lista falla o llega incompleta NO se
// filtra nada (mismo comportamiento que antes: mejor de mas que de menos).
// ------------------------------------------------------------

const MARKET_HANDLES_URL = window.YUXUS_MARKET_HANDLES_URL || '/collections/all?view=market-handles';
const MARKET_HANDLES_KEY = 'yuxus_market_handles_v1_' + COUNTRY + '_' + LOCALE;
const MARKET_HANDLES_MAX_PAGES = 60;

let marketHandles = null;
let marketHandlesPromise = null;

function _marketHandlesFetch(page) {
  var sep = MARKET_HANDLES_URL.indexOf('?') === -1 ? '?' : '&';
  return fetch(MARKET_HANDLES_URL + sep + 'page=' + page)
    .then(function(r) { return r.ok ? r.text() : ''; })
    .then(function(t) {
      var data = JSON.parse(t);
      if (!data || !Array.isArray(data.handles)) throw new Error('bad payload');
      return data;
    });
}

async function loadMarketHandles() {
  if (marketHandles) return marketHandles;
  if (marketHandlesPromise) return marketHandlesPromise;

  try {
    var cached = sessionStorage.getItem(MARKET_HANDLES_KEY);
    if (cached) {
      var arr = JSON.parse(cached);
      if (Array.isArray(arr) && arr.length > 0) {
        marketHandles = new Set(arr);
        return marketHandles;
      }
    }
  } catch (e) {}

  marketHandlesPromise = (async function() {
    try {
      var first = await _marketHandlesFetch(1);
      var handles = first.handles.slice();
      var pages = Math.min(parseInt(first.pages, 10) || 1, MARKET_HANDLES_MAX_PAGES);

      if (pages > 1) {
        var reqs = [];
        for (var pg = 2; pg <= pages; pg++) reqs.push(_marketHandlesFetch(pg));
        var rest = await Promise.all(reqs);
        for (var i = 0; i < rest.length; i++) handles = handles.concat(rest[i].handles);
      }

      if (handles.length === 0) throw new Error('empty');

      marketHandles = new Set(handles);
      try { sessionStorage.setItem(MARKET_HANDLES_KEY, JSON.stringify(handles)); } catch (e) {}
    } catch (e) {
      // Sin lista blanca fiable no se filtra: la vista puede no existir todavia
      // en el tema, o alguna pagina haber fallado.
      marketHandles = null;
    }
    marketHandlesPromise = null;
    return marketHandles;
  })();

  return marketHandlesPromise;
}

function filterByMarket(list) {
  if (!marketHandles || marketHandles.size === 0) return list || [];
  if (!list || !list.length) return list || [];
  var out = [];
  for (var i = 0; i < list.length; i++) {
    var p = list[i];
    if (p && p.handle && marketHandles.has(p.handle)) out.push(p);
  }
  return out;
}

const _marketHandlesReady = loadMarketHandles();

let searchIndex = null;
let groupHexIndex = null;
let searchIndexBuiltFromCount = 0;
let searchCache = new Map();

let _searchReadyResolve;
let searchReadyPromise = new Promise(function(resolve) { _searchReadyResolve = resolve; });
let searchReady = false;

async function loadSalesData() {
  if (salesDataLoaded && salesDataCache) return salesDataCache;
  if (salesDataPromise) return salesDataPromise;
  
  salesDataPromise = (async function() {
    try {
      var response = await fetch(SEARCH_DATA_URL + '?v=' + Date.now());
      if (response.ok) {
        salesDataCache = await response.json();
        if (salesDataCache && Array.isArray(salesDataCache.products)) {
          salesDataCache.products = salesDataCache.products.filter(function(p) {
            return !_isHiddenDropProduct(p);
          });
        }
      } else {
        salesDataCache = { products: [] };
      }
    } catch (error) {
      salesDataCache = { products: [] };
    }
    salesDataLoaded = true;
    
    salesUnitsMap = new Map();
    if (salesDataCache.products) {
      for (var i = 0; i < salesDataCache.products.length; i++) {
        var p = salesDataCache.products[i];
        if (p.handle) salesUnitsMap.set(p.handle, p.salesUnits || 0);
      }
    }
    
    salesDataPromise = null;
    return salesDataCache;
  })();
  
  return salesDataPromise;
}

function getSalesUnits(handle) {
  if (salesUnitsMap) return salesUnitsMap.get(handle) || 0;
  return 0;
}

async function getAllProducts() {
  if (productsLoaded && allProductsCache) return allProductsCache;
  if (productsPromise) return productsPromise;
  
  productsPromise = (async function() {
    try {
      allProductsCache = await fetchAllShopifyProducts();
    } catch (e) {
      allProductsCache = [];
    }
    productsLoaded = true;
    productsPromise = null;
    
    try { _onShopifyProductsLoaded(); } catch(e) {}
    
    return allProductsCache || [];
  })();
  
  return productsPromise;
}

function preloadProducts() {
  if (!productsLoaded && !productsPromise) getAllProducts();
}

function _isHiddenDropProduct(p) {
  if (!p || !p.tags) return false;
  if (typeof p.tags === 'string') {
    return p.tags.toLowerCase().indexOf('hidden-drops') !== -1;
  }
  if (Array.isArray(p.tags)) {
    for (var i = 0; i < p.tags.length; i++) {
      if (String(p.tags[i]).toLowerCase() === 'hidden-drops') return true;
    }
  }
  return false;
}

async function fetchAllShopifyProducts() {
  var primary = await fetchAllShopifyProductsAPI();
  if (primary && primary.length > 0) {
    return primary;
  }
  
  var allProducts = [];
  var existingHandles = new Set();
  
  try {
    var firstResponse = await fetch('/collections/all?view=json-products');
    var firstText = await firstResponse.text();
    var parser = new DOMParser();
    var doc = parser.parseFromString(firstText, 'text/html');
    var scriptEl = doc.querySelector('#SelectedCollectionJSON');
    
    if (!scriptEl) return [];
    
    var firstProducts = JSON.parse(scriptEl.textContent || '[]');
    for (var i = 0; i < firstProducts.length; i++) {
      var p = firstProducts[i];
      if (p && p.handle && !existingHandles.has(p.handle) && !_isHiddenDropProduct(p)) {
        allProducts.push(p);
        existingHandles.add(p.handle);
      }
    }
    
    var page = 2;
    var hasMore = true;
    while (hasMore && page <= 50) {
      var batch = [];
      for (var b = 0; b < 3 && page <= 50; b++, page++) {
        batch.push(fetch('/collections/all?view=json-products&page=' + page).then(function(r) { return r.text(); }));
      }
      
      var results = await Promise.all(batch.map(function(p) { return p.catch(function() { return ''; }); }));
      var foundAny = false;
      
      for (var ri = 0; ri < results.length; ri++) {
        if (!results[ri]) continue;
        try {
          var pageDoc = parser.parseFromString(results[ri], 'text/html');
          var pageScript = pageDoc.querySelector('#SelectedCollectionJSON');
          if (pageScript) {
            var pageProducts = JSON.parse(pageScript.textContent || '[]');
            if (pageProducts.length === 0) continue;
            foundAny = true;
            for (var pi = 0; pi < pageProducts.length; pi++) {
              var pp = pageProducts[pi];
              if (pp && pp.handle && !existingHandles.has(pp.handle) && !_isHiddenDropProduct(pp)) {
                allProducts.push(pp);
                existingHandles.add(pp.handle);
              }
            }
          }
        } catch(e) {}
      }
      
      if (!foundAny) hasMore = false;
    }
  } catch (e) {}
  
  return allProducts;
}

async function fetchAllShopifyProductsAPI() {
  var allProducts = [];
  var page = 1;
  var hasMore = true;
  
  while (hasMore && page <= 20) {
    try {
      var response = await fetch('/products.json?limit=250&page=' + page);
      if (!response.ok) { hasMore = false; break; }
      var data = await response.json();
      var products = data.products || [];
      
      if (products.length === 0) {
        hasMore = false;
      } else {
        for (var i = 0; i < products.length; i++) {
          if (_isHiddenDropProduct(products[i])) continue;
          allProducts.push(products[i]);
        }
        page++;
        if (products.length < 250) hasMore = false;
      }
    } catch (e) {
      hasMore = false;
    }
  }
  return allProducts;
}

let _mergedDataset = null;
let _lastSearchQuery = null;
let _lastSearchIsMobile = null;

// Recalcula precio/rebaja desde las variantes VIVAS (/products.json) para que el
// search refleje siempre el precio actual, igual que el grid (compare_at_price_max
// vs precio mínimo). Los campos price_num/compare_num del JSON estático son un
// snapshot y quedan desactualizados en cada cambio de rebaja: aquí los pisamos.
function _livePricesFromVariants(variants) {
  if (!variants || !variants.length) return null;
  var minPrice = Infinity, maxCompare = 0;
  for (var i = 0; i < variants.length; i++) {
    var v = variants[i] || {};
    var pr = parseFloat(String(v.price != null ? v.price : '').replace(/[^0-9.]/g, '')) || 0;
    var cpRaw = v.compare_at_price != null ? v.compare_at_price : v.compareAtPrice;
    var cp = parseFloat(String(cpRaw != null ? cpRaw : '').replace(/[^0-9.]/g, '')) || 0;
    if (pr > 0 && pr < minPrice) minPrice = pr;
    if (cp > maxCompare) maxCompare = cp;
  }
  if (minPrice === Infinity) return null;
  return { price_num: minPrice, compare_num: maxCompare > minPrice ? maxCompare : 0 };
}

function buildMergedDataset() {
  if (allProductsCache && allProductsCache.length > 0) {
    var jsonByHandle = new Map();
    if (salesDataCache && salesDataCache.products) {
      for (var i = 0; i < salesDataCache.products.length; i++) {
        var jp = salesDataCache.products[i];
        if (jp.handle) jsonByHandle.set(jp.handle, jp);
      }
    }
    
    var merged = [];
    for (var j = 0; j < allProductsCache.length; j++) {
      var sp = allProductsCache[j];
      if (!sp.handle) continue;
      var enriched = jsonByHandle.get(sp.handle);
      if (enriched) {
        var combined = Object.assign({}, enriched);
        if (sp.tags) combined.tags = sp.tags;
        if (sp.variants) combined.variants = sp.variants;
        if (sp.available !== undefined) combined.available = sp.available;
        // Precio/rebaja SIEMPRE desde variantes vivas (no del snapshot estático).
        var live = _livePricesFromVariants(sp.variants);
        if (live) { combined.price_num = live.price_num; combined.compare_num = live.compare_num; }
        merged.push(combined);
      } else {
        // Producto no presente en el JSON estático: calcula precio/rebaja de sus
        // variantes vivas para no depender de variants[0] en buildSearchIndex.
        var liveSp = _livePricesFromVariants(sp.variants);
        if (liveSp) { sp.price_num = liveSp.price_num; sp.compare_num = liveSp.compare_num; }
        merged.push(sp);
      }
    }
    _mergedDataset = filterByMarket(merged);
    return _mergedDataset;
  }
  
  if (salesDataCache && salesDataCache.products && salesDataCache.products.length > 0) {
    _mergedDataset = filterByMarket(salesDataCache.products);
    return _mergedDataset;
  }
  
  _mergedDataset = [];
  return _mergedDataset;
}

(async function _smartPreload() {
  try {
    await loadSalesData();
    // Como mucho 2s esperando la lista blanca del mercado: si tarda mas, el
    // indice arranca sin filtrar y se reconstruye en cuanto llegue.
    await Promise.race([
      _marketHandlesReady,
      new Promise(function(r) { setTimeout(r, 2000); })
    ]);
    
    if (salesDataCache && salesDataCache.products && salesDataCache.products.length > 0) {
      var jsonProducts = filterByMarket(salesDataCache.products);
      if (window.requestIdleCallback) {
        requestIdleCallback(function() {
          buildSearchIndex(jsonProducts);
          _mergedDataset = jsonProducts;
          searchReady = true;
          _searchReadyResolve();
        });
      } else {
        setTimeout(function() {
          buildSearchIndex(jsonProducts);
          _mergedDataset = jsonProducts;
          searchReady = true;
          _searchReadyResolve();
        }, 50);
      }
    } else {
      searchReady = true;
      _searchReadyResolve();
    }
  } catch(e) {
    searchReady = true;
    _searchReadyResolve();
  }
  
  setTimeout(function() {
    if (!productsLoaded && !productsPromise) {
      getAllProducts();
    }
  }, 200);
})();

function _rerunLastSearch() {
  if (!_lastSearchQuery) return;
  if (!mobileSearchActive && !desktopSearchActive) return;
  var activeInput = _lastSearchIsMobile ? mobileSearchInput : desktopSearchInput;
  if (activeInput && activeInput.value.trim() === _lastSearchQuery) {
    performSearch(_lastSearchQuery, _lastSearchIsMobile);
  }
}

// La lista blanca del mercado puede llegar despues del primer indice (arriba se
// espera 2s como mucho). Si llega tarde, se reconstruye el indice ya filtrado.
_marketHandlesReady.then(function() {
  if (!marketHandles || !searchIndex) return;
  var dataset = (allProductsCache && allProductsCache.length > 0)
    ? buildMergedDataset()
    : filterByMarket((salesDataCache && salesDataCache.products) || []);
  if (!dataset || dataset.length === 0) return;
  _mergedDataset = dataset;
  searchCache.clear();
  buildSearchIndex(dataset, true);
  _rerunLastSearch();
}).catch(function() {});

function _onShopifyProductsLoaded() {
  if (!allProductsCache || allProductsCache.length === 0) return;
  
  var newDataset = buildMergedDataset();
  if (!newDataset || newDataset.length === 0) return;
  
  buildSearchIndex(newDataset, true);
  _rerunLastSearch();
}


// ============================================================
// SECCIÓN 2B: ÍNDICE DE BÚSQUEDA
// ============================================================

function buildSearchIndex(productsRaw, forceRebuild) {
  if (searchIndex && !forceRebuild && productsRaw.length <= searchIndexBuiltFromCount) {
    return;
  }
  
  if (searchIndex) {
    searchCache.clear();
  }
  
  var idx = new Array(productsRaw.length);
  var gIdx = new Map();
  
  for (var i = 0; i < productsRaw.length; i++) {
    var p = productsRaw[i];
    var title = p.title || '';
    var titleNorm = normalizeText(title);
    var titleWords = titleNorm.split(/[\s\-_\/]+/).filter(function(w) { return w.length > 1; });
    var handle = p.handle || '';
    var handleWords = handle.split(/[\s\-_\/]+/).filter(function(w) { return w.length > 1; });
    
    var tags = [];
    if (Array.isArray(p.tags)) tags = p.tags;
    else if (typeof p.tags === 'string') tags = p.tags.split(',').map(function(t) { return t.trim(); });
    
    var tagsUpper = tags.map(function(t) { return t.toUpperCase(); });
    var tagsNorm = tags.map(function(t) { return normalizeText(t); });
    
    var groupTag = '';
    var hexVal = '';
    for (var ti = 0; ti < tags.length; ti++) {
      var tl = tags[ti].toLowerCase().trim();
      if (tl.indexOf('group_') === 0 && !groupTag) groupTag = tl;
      if (tags[ti].indexOf('hex_') === 0 && !hexVal) hexVal = tags[ti].replace('hex_', '');
    }
    
    var productType = p.product_type || p.productType || p.type || '';
    var productTypeNorm = normalizeText(productType);
    var productTypeWords = productTypeNorm.split(/[\s\-_\/]+/).filter(function(w) { return w.length > 1; });
    var category = getCategoryFromTitle(title);
    if (productTypeNorm === 'cap' || productTypeNorm === 'caps') {
      category = category.concat(['cap']);
    }
    var color = getColorFromTags(tags);
    
    var hasStock = false;
    var stockCount = 0;
    var variants = p.variants || [];
    for (var vi = 0; vi < variants.length; vi++) {
      if (variants[vi].available !== false) {
        hasStock = true;
        stockCount++;
      }
    }
    
    var salesUnits = getSalesUnits(handle);
    
    var allWords = titleWords.concat(handleWords).concat(productTypeWords);
    for (var tni = 0; tni < tagsNorm.length; tni++) {
      var tw = tagsNorm[tni].split(/[\s\-_]+/);
      for (var twi = 0; twi < tw.length; twi++) {
        if (tw[twi].length > 1) allWords.push(tw[twi]);
      }
    }
    
    idx[i] = {
      titleNorm: titleNorm,
      titleWords: titleWords,
      handleWords: handleWords,
      tags: tags,
      tagsUpper: tagsUpper,
      tagsNorm: tagsNorm,
      groupTag: groupTag,
      hexVal: hexVal,
      category: category,
      productTypeNorm: productTypeNorm,
      color: color,
      hasStock: hasStock,
      stockCount: stockCount,
      salesUnits: salesUnits,
      allWords: allWords
    };
    
    if (groupTag && hexVal) {
      var url = p.url || ('/products/' + p.handle);
      var firstImage = '';
      if (p.images_array && p.images_array[0]) firstImage = p.images_array[0];
      else if (p.images && p.images.length > 0) {
        var img0 = p.images[0];
        firstImage = typeof img0 === 'string' ? img0 : (img0.src || img0.url || '');
      } else if (p.image) {
        firstImage = typeof p.image === 'string' ? p.image : (p.image.src || '');
      }
      var pTitle = title.replace(/;;;/g, '').replace(/\|\|\|/g, '');
      
      // FIX MONEDA: extraer SIEMPRE el número y reformatear con la divisa actual
      var pPriceNum = 0, pCompareNum = 0;
      if (p.price_num !== undefined) {
        pPriceNum = parseFloat(p.price_num) || 0;
        pCompareNum = parseFloat(p.compare_num) || 0;
      } else if (p.variants && p.variants[0]) {
        var vPrice = p.variants[0].price;
        pPriceNum = vPrice ? parseFloat(String(vPrice).replace(/[^0-9.]/g, '')) : 0;
        var vCompare = p.variants[0].compare_at_price || p.variants[0].compareAtPrice;
        pCompareNum = vCompare ? parseFloat(String(vCompare).replace(/[^0-9.]/g, '')) : 0;
      } else if (p.price) {
        pPriceNum = parseFloat(String(p.price).replace(/[^0-9.]/g, '')) || 0;
        if (p.compareAtPrice) {
          pCompareNum = parseFloat(String(p.compareAtPrice).replace(/[^0-9.]/g, '')) || 0;
        }
      }
      
      // Reformatear con la divisa actual (NO usar p.price_str del JSON externo)
      var pPriceStr = pPriceNum > 0 ? formatShopifyPrice(pPriceNum) : '';
      var pCompareStr = pCompareNum > 0 ? formatShopifyPrice(pCompareNum) : '';
      
      if (!gIdx.has(groupTag)) gIdx.set(groupTag, []);
      gIdx.get(groupTag).push({
        hex: hexVal, url: url, image: firstImage, title: pTitle,
        priceStr: pPriceStr, compareStr: pCompareStr, priceNum: pPriceNum, compareNum: pCompareNum
      });
    }
  }
  
  searchIndex = idx;
  groupHexIndex = gIdx;
  searchIndexBuiltFromCount = productsRaw.length;
}


// ============================================================
// SECCIÓN 3: ELEMENTOS DEL DOM
// ============================================================

const mobileSearchInline = document.getElementById('mobileSearchInline');
const mobileSearchClose = document.getElementById('mobileSearchClose');
const mobileSearchInput = document.getElementById('mobileSearchInput');
const mobileSearchSubmit = document.getElementById('mobileSearchSubmit');
const mobileSearchResultsCarousel = document.getElementById('mobileSearchResultsCarousel');
const mobileSearchResultsInner = document.getElementById('mobileSearchResultsInner');
const mobileSearchResultsCount = document.getElementById('mobileSearchResultsCount');
const openSearchBtnMobile = document.getElementById('open-search-btn-mobile2');
const mobileHeaderLeft = document.getElementById('mobileHeaderLeft') || document.querySelector('.header-mobile-left');
const mobileHeaderRight = document.getElementById('mobileHeaderRight') || document.querySelector('.header-mobile-right');

const openSearchBtnDesktop = document.getElementById('open-search-btn-desktop');
const headerIconsGroup = document.getElementById('headerIconsGroup');
const desktopSearchInline = document.getElementById('desktopSearchInline');
const desktopSearchClose = document.getElementById('desktopSearchClose');
const desktopSearchInput = document.getElementById('desktopSearchInput');
const searchResultsCarousel = document.getElementById('searchResultsCarousel');
const searchResultsCarouselInner = document.getElementById('searchResultsCarouselInner');
const searchResultsCount = document.getElementById('searchResultsCount');

// ============================================================
// SECCIÓN 4: HEIGHT CALCULATION HELPERS
// ============================================================
function calculateMobileHeaderBottom() {
  var isMobile = window.innerWidth < 768;
  // 768-1199 (tablet / ventana partida) tambien usa el header movil, pero sin el CSS
  // fijo de <=767: se mide su borde real. Con el 120 fijo quedaba una franja entre el
  // header y el panel por la que se veia el banner.
  if (!isMobile) {
    var uc = document.getElementById('unifiedHeader') || document.querySelector('.unified-header-container');
    var ub = uc ? Math.round(uc.getBoundingClientRect().bottom) : 0;
    return ub > 50 ? ub : 120;
  }

  var isProductPage = document.body.classList.contains('template-product') || 
                      window.location.pathname.includes('/products/');
  
  var unifiedContainer = document.getElementById('unifiedHeader') || document.querySelector('.unified-header-container');
  var fallbackBottom = isProductPage ? 88 : 120;
  if (unifiedContainer) {
    var unifiedRect = unifiedContainer.getBoundingClientRect();
    if (unifiedRect.bottom > 0) {
      fallbackBottom = Math.round(unifiedRect.bottom);
    }
  }
  
  var totalHeight = 26;
  
  var siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    var headerMobile = siteHeader.querySelector('.header-mobile');
    totalHeight += (headerMobile ? headerMobile.offsetHeight : 40) || 40;
  } else {
    totalHeight += 40;
  }
  
  if (!isProductPage) {
    var menuCarouselBar = document.getElementById('menuCarouselBar');
    if (menuCarouselBar && menuCarouselBar.offsetParent !== null && menuCarouselBar.offsetHeight > 0) {
      totalHeight += menuCarouselBar.offsetHeight;
    } else {
      totalHeight += 32;
    }
  }
  
  if (totalHeight < 50 || isNaN(totalHeight)) {
    totalHeight = fallbackBottom;
  }
  
  return totalHeight;
}

function calculateDesktopHeaderBottom() {
  var isProductPage = document.body.classList.contains('template-product') || 
                      window.location.pathname.includes('/products/');
  var headerBottom = 120;
  
  var siteHeader = document.querySelector('.site-header');
  var unifiedContainer = document.getElementById('unifiedHeader') || document.querySelector('.unified-header-container');
  
  var fallbackBottom = 120;
  if (unifiedContainer) {
    var unifiedRect = unifiedContainer.getBoundingClientRect();
    if (unifiedRect.bottom > 0) {
      fallbackBottom = Math.round(unifiedRect.bottom);
    }
  } else if (siteHeader) {
    var siteRect = siteHeader.getBoundingClientRect();
    if (siteRect.bottom > 0) {
      fallbackBottom = Math.round(siteRect.bottom);
    }
  }
  
  if (isProductPage) {
    if (siteHeader) {
      var headerDesktop = siteHeader.querySelector('.header-desktop');
      var el = headerDesktop || siteHeader;
      var rect = el.getBoundingClientRect();
      if (rect.bottom > 0) {
        headerBottom = Math.round(rect.bottom);
      } else {
        headerBottom = fallbackBottom;
      }
    } else {
      headerBottom = fallbackBottom;
    }
  } else {
    var menuCarouselBar = document.getElementById('menuCarouselBar');
    if (menuCarouselBar && menuCarouselBar.offsetHeight > 0) {
      var barRect = menuCarouselBar.getBoundingClientRect();
      if (barRect.bottom > 0) {
        headerBottom = Math.round(barRect.bottom);
      } else {
        headerBottom = fallbackBottom;
      }
    } else {
      headerBottom = fallbackBottom;
    }
  }
  
  if (headerBottom < 70 || isNaN(headerBottom)) {
    headerBottom = isProductPage ? 80 : 120;
  }
  return headerBottom;
}

function getSearchPanelCSS(isMobile, headerBottom, availableHeight) {
  var isProductPage = document.body.classList.contains('template-product') || 
                      window.location.pathname.includes('/products/');
  var bg = isProductPage ? '#ffffff' : '#f8f8f8';
  var zIdx = isMobile ? '999990' : '999995';
  var pad = isMobile ? '0 0 80px 0' : '10px 0 80px 0';
  
  return 'display:block!important;' +
    'position:fixed!important;' +
    'top:' + headerBottom + 'px!important;' +
    'left:0!important;right:0!important;' +
    'width:100%!important;' +
    'height:' + availableHeight + 'px!important;' +
    'max-height:' + availableHeight + 'px!important;' +
    'overflow-y:auto!important;overflow-x:hidden!important;' +
    'background:' + bg + '!important;' +
    'z-index:' + zIdx + '!important;' +
    '-webkit-overflow-scrolling:touch!important;' +
    (isMobile ? 'overscroll-behavior-y:contain!important;' : '') +
    'padding:' + pad + '!important;' +
    (isMobile ? 'margin:0!important;' : '');
}

function getSearchPanelCSSAuto(isMobile, headerBottom, availableHeight) {
  var isProductPage = document.body.classList.contains('template-product') || 
                      window.location.pathname.includes('/products/');
  var bg = isProductPage ? '#ffffff' : '#f8f8f8';
  var zIdx = isMobile ? '999990' : '999995';
  var pad = isMobile ? '0 0 80px 0' : '10px 0 80px 0';
  
  return 'display:block!important;' +
    'position:fixed!important;' +
    'top:' + headerBottom + 'px!important;' +
    'left:0!important;right:0!important;' +
    'width:100%!important;' +
    'height:auto!important;' +
    'max-height:' + availableHeight + 'px!important;' +
    'overflow-y:auto!important;overflow-x:hidden!important;' +
    'background:' + bg + '!important;' +
    'z-index:' + zIdx + '!important;' +
    '-webkit-overflow-scrolling:touch!important;' +
    (isMobile ? 'overscroll-behavior-y:contain!important;' : '') +
    'padding:' + pad + '!important;' +
    (isMobile ? 'margin:0!important;' : '');
}

// ============================================================
// SECCIÓN 5: ABRIR/CERRAR BÚSQUEDA MÓVIL
// ============================================================
let mobileSearchActive = false;
let _mobileSearchOpenedAt = 0;

function openMobileSearchInline(e) {
  e && e.preventDefault();
  
  if (mobileSearchActive) return;
  mobileSearchActive = true;
  _mobileSearchOpenedAt = Date.now();
  
  preloadProducts();
  
  var currentScroll = _getScrollY();
  document.body.dataset.scrollY = currentScroll;
  
  var promoBarWrapper = document.getElementById('promoBarWrapper');
  var unifiedContainer = document.querySelector('.unified-header-container');
  
  if (promoBarWrapper) promoBarWrapper.classList.remove('scroll-hidden');
  if (unifiedContainer) unifiedContainer.style.transition = 'none';
  
  document.body.classList.add('mobile-search-active');
  
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  document.body.style.top = '0px';
  
  void document.body.offsetHeight;
  
  var preHeaderBottom = calculateMobileHeaderBottom();
  var preAvailableHeight = window.innerHeight - preHeaderBottom;
  if (mobileSearchResultsCarousel) {
    mobileSearchResultsCarousel.style.cssText = getSearchPanelCSSAuto(true, preHeaderBottom, preAvailableHeight);
  }
  
  if (mobileHeaderLeft) mobileHeaderLeft.style.opacity = '0';
  if (mobileHeaderRight) mobileHeaderRight.style.opacity = '0';
  
  setTimeout(function() {
    // Si se cerro en estos 50ms no se vuelve a pintar (dejaba el panel colgado)
    if (!mobileSearchActive) return;
    if (mobileHeaderLeft) mobileHeaderLeft.classList.add('hidden');
    if (mobileHeaderRight) mobileHeaderRight.classList.add('hidden');
    
    if (mobileSearchInline) mobileSearchInline.classList.add('active');
    
    void document.body.offsetHeight;
    
    var headerBottom = calculateMobileHeaderBottom();
    var availableHeight = window.innerHeight - headerBottom;
    
    if (mobileSearchResultsCarousel) {
      mobileSearchResultsCarousel.style.cssText = getSearchPanelCSSAuto(true, headerBottom, availableHeight);
      mobileSearchResultsCarousel.classList.add('active');
      mobileSearchResultsCarousel.scrollTop = 0;
    }
    
    var trendingSection = document.getElementById('searchTrendingSection');
    var linksSection = document.getElementById('searchLinksSection');
    var collectionsCarousel = document.getElementById('mobileSearchCollectionsCarousel');
    
    if (trendingSection) {
      trendingSection.style.cssText = 'display:block!important;padding:18px 10px 8px 10px!important;margin:0!important;';
      trendingSection.classList.add('active');
    }
    if (linksSection) {
      linksSection.style.cssText = 'display:block!important;padding:6px 10px 15px 10px!important;margin:0!important;';
      linksSection.classList.add('active');
    }
    if (collectionsCarousel) {
      collectionsCarousel.style.cssText = 'display:none!important;';
    }
    
    if (mobileSearchResultsInner) mobileSearchResultsInner.innerHTML = '';
    if (mobileSearchResultsCount) mobileSearchResultsCount.textContent = '';
    
    if (mobileSearchInput) {
      mobileSearchInput.focus();
      requestAnimationFrame(function() {
        if (mobileSearchInput && document.activeElement !== mobileSearchInput) {
          mobileSearchInput.focus();
        }
      });
    }
  }, 50);
}

function closeMobileSearchInline() {
  if (!mobileSearchActive) return;
  mobileSearchActive = false;
  _lastSearchQuery = null;
  
  document.body.classList.remove('mobile-search-active');
  
  var scrollY = parseInt(document.body.dataset.scrollY || 0);
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.width = '';
  document.body.style.top = '';
  
  var unifiedContainer = document.querySelector('.unified-header-container');
  if (unifiedContainer) unifiedContainer.style.transition = '';
  
  var unifiedHeader = document.getElementById('unifiedHeader');
  if (unifiedHeader) unifiedHeader.style.removeProperty('z-index');
  
  if (mobileSearchInline) mobileSearchInline.classList.remove('active');
  if (mobileSearchInput) mobileSearchInput.value = '';
  
  if (mobileSearchResultsCarousel) {
    mobileSearchResultsCarousel.classList.remove('active');
    mobileSearchResultsCarousel.style.cssText = '';
  }
  if (mobileSearchResultsInner) mobileSearchResultsInner.innerHTML = '';
  if (mobileSearchResultsCount) mobileSearchResultsCount.textContent = '';
  
  var trendingSection = document.getElementById('searchTrendingSection');
  var linksSection = document.getElementById('searchLinksSection');
  var collectionsCarousel = document.getElementById('mobileSearchCollectionsCarousel');
  
  if (trendingSection) { trendingSection.classList.remove('active'); trendingSection.style.cssText = ''; }
  if (linksSection) { linksSection.classList.remove('active'); linksSection.style.cssText = ''; }
  if (collectionsCarousel) { collectionsCarousel.style.cssText = ''; }
  
  if (mobileHeaderLeft) {
    mobileHeaderLeft.classList.remove('hidden');
    mobileHeaderLeft.style.opacity = '0';
    setTimeout(function() { mobileHeaderLeft.style.opacity = '1'; }, 10);
  }
  if (mobileHeaderRight) {
    mobileHeaderRight.classList.remove('hidden');
    mobileHeaderRight.style.opacity = '0';
    setTimeout(function() { mobileHeaderRight.style.opacity = '1'; }, 10);
  }
  
  setTimeout(function() { window.scrollTo(0, scrollY); }, 50);
}

if (openSearchBtnMobile) openSearchBtnMobile.addEventListener('click', openMobileSearchInline);
if (mobileSearchClose) mobileSearchClose.addEventListener('click', closeMobileSearchInline);

// ============================================================
// Recalcular posición del carousel en resize/rotación
// ============================================================
var _resizeRecalcTimer = null;
function recalcSearchCarouselPosition() {
  if (_resizeRecalcTimer) clearTimeout(_resizeRecalcTimer);
  _resizeRecalcTimer = setTimeout(function() {
    // Al cruzar 1200px (redimensionar / partir la ventana) el header que tiene la X
    // se oculta y el panel se quedaba bloqueando la web: se cierra la busqueda.
    var wideHeader = window.innerWidth >= 1200;
    if (desktopSearchActive && !wideHeader) { closeDesktopSearch(); return; }
    if (mobileSearchActive && wideHeader) { closeMobileSearchInline(); return; }
    if (desktopSearchActive && searchResultsCarousel) {
      var hb = calculateDesktopHeaderBottom();
      var ah = window.innerHeight - hb;
      searchResultsCarousel.style.cssText = getSearchPanelCSSAuto(false, hb, ah);
      searchResultsCarousel.classList.add('active');
    }
    if (mobileSearchActive && mobileSearchResultsCarousel) {
      var hbm = calculateMobileHeaderBottom();
      var ahm = window.innerHeight - hbm;
      mobileSearchResultsCarousel.style.cssText = getSearchPanelCSSAuto(true, hbm, ahm);
      mobileSearchResultsCarousel.classList.add('active');
    }
  }, 100);
}
window.addEventListener('resize', recalcSearchCarouselPosition, { passive: true });
window.addEventListener('orientationchange', recalcSearchCarouselPosition, { passive: true });
// Volver atras (bfcache) restauraba la pagina con la busqueda abierta
window.addEventListener('pageshow', function(e) {
  if (!e.persisted) return;
  if (desktopSearchActive) closeDesktopSearch();
  if (mobileSearchActive) closeMobileSearchInline();
});

// ============================================================
// KEY BUFFER
// ============================================================
document.addEventListener('keydown', function(e) {
  if (!mobileSearchActive && !desktopSearchActive) return;
  
  var activeInput = mobileSearchActive ? mobileSearchInput : desktopSearchInput;
  if (!activeInput) return;
  
  if (document.activeElement === activeInput) return;
  
  var now = Date.now();
  var openedAt = mobileSearchActive ? _mobileSearchOpenedAt : _desktopSearchOpenedAt;
  if (now - openedAt > 500) return;
  
  if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
    e.preventDefault();
    activeInput.value += e.key;
    activeInput.focus();
    activeInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
}, true);

// ============================================================
// SECCIÓN 6: ABRIR/CERRAR BÚSQUEDA DESKTOP
// ============================================================
let desktopSearchActive = false;
let desktopSearchOpenTimer = null;
let _desktopSearchOpenedAt = 0;

function createDesktopTrendingLinks() {
  var searchResultsEl = document.getElementById('searchResultsCarousel');
  if (!searchResultsEl) return;
  if (document.getElementById('desktopTrendingSection')) return;
  
  var trendingHTML = `
    <div class="search-trending-section" id="desktopTrendingSection" style="display:none;">
      <div class="search-trending-title">${T.mostSearched}</div>
      <div class="search-trending-items">
        <a href="${ROOT}/collections/new-arrivals" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/1-NEW_ARRIVAL_951128d4-b7c6-4c54-8f4c-59f1674ff538.webp?v=1779182499&width=900" alt="New Arrivals" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">${T.newArrivals}</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/bestsellers" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/2-BESTSELLERS.webp?v=1779179285&width=900" alt="Bestsellers" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">Bestsellers</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/hoodies" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/IMG_0250_copia_2_1.webp?v=1776088264&width=900" alt="Hoodies" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">${T.hoodies}</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/t-shirts" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/Copia_de_IMG_9357.webp?v=1777528067&width=900" alt="T-Shirts" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">T-Shirts</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/crewnecks" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/IMG_6915_1.webp?v=1771485855&width=900" alt="Crewnecks" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">Crewnecks</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/longsleeves" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/IMG_0208_copia.webp?v=1773657667&width=900" alt="Longsleeves" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">Longsleeves</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/polos-shirts" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/CopiadeIMG_3039copia_ba6b1d9f-eb51-4a9c-ba2a-cd393eac53cb.webp?v=1771418400&width=900" alt="Polos" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">Polos & Shirts</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/zips-half-zips" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/WOMAN.jpg?v=1767596668&width=900" alt="Zips" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">Zips & Half Zips</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/knit" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/knitwear.webp?v=1771418402&width=900" alt="Knitwear" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">Knitwear</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/outerwear" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/ABRIGOS_Y_CHAQUETAS_5b23f28a-0e39-4470-9baa-ab133669e1d8.webp?v=1779283598&width=900" alt="Outerwear" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">Outerwear</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/pants" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/7-pants.webp?v=1765870098&width=900" alt="Pants" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">${T.pants}</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/woman" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/FOTO_CARROUSEL-WOMAN.webp?v=1772541335&width=900" alt="Woman" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">Woman</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/accessories" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/ACCESORIES_1.webp?v=1779268205&width=900" alt="Accessories" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">${T.accessories}</span></div>
          </div>
        </a>
        <a href="${ROOT}/collections/all" class="search-trending-item">
          <div class="search-trending-item-image-wrap">
            <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0715/1822/4676/files/all_copia_7f2ec70b-66de-447b-8ff9-6c140792d5c8.webp?v=1762464453&width=900" alt="All" class="search-trending-item-image">
            <div class="search-trending-item-content"><span class="search-trending-item-label">${T.viewAll}</span></div>
          </div>
        </a>
      </div>
    </div>
    <div class="search-links-section" id="desktopLinksSection" style="display:none;">
      <div class="search-links-title">${T.usefulLinks}</div>
      <div class="search-links-items">
        <a href="${ROOT}/pages/shipping-policy" class="search-links-item">${T.shippingPolicy}</a>
        <a href="${ROOT}/pages/returns-exchanges" class="search-links-item">${T.returnsExchanges}</a>
        <a href="${ROOT}/pages/stores" class="search-links-item">${T.stores}</a>
      </div>
    </div>
  `;
  
  searchResultsEl.insertAdjacentHTML('afterbegin', trendingHTML);

  // Mirror the footer Collection Carousel onto the just-created trending list
  // synchronously, while it is still display:none, so no hardcoded image flashes.
  if (window.__SEARCH_CC_SYNC__) window.__SEARCH_CC_SYNC__();
}

function openDesktopSearch() {
  if (desktopSearchOpenTimer) { clearTimeout(desktopSearchOpenTimer); desktopSearchOpenTimer = null; }
  
  desktopSearchActive = true;
  _desktopSearchOpenedAt = Date.now();
  preloadProducts();
  
  document.body.classList.add('desktop-search-active');
  
  var wasInHeroMode = document.body.classList.contains('header-hero-mode');
  if (wasInHeroMode) document.body.classList.remove('header-hero-mode');
  
  if (headerIconsGroup) headerIconsGroup.style.opacity = '0';
  
  var preHeaderBottom = calculateDesktopHeaderBottom();
  var preAvailableHeight = window.innerHeight - preHeaderBottom;
  if (searchResultsCarousel) {
    searchResultsCarousel.style.cssText = getSearchPanelCSSAuto(false, preHeaderBottom, preAvailableHeight);
  }
  
  var openDelay = wasInHeroMode ? 420 : 150;
  
  desktopSearchOpenTimer = setTimeout(function() {
    desktopSearchOpenTimer = null;
    if (!desktopSearchActive) return;
    
    if (headerIconsGroup) headerIconsGroup.style.display = 'none';
    if (desktopSearchInline) {
      desktopSearchInline.classList.add('active');
      _desktopSearchOpenedAt = Date.now();
      setTimeout(function() { if (desktopSearchInput && desktopSearchActive) desktopSearchInput.focus(); }, 300);
    }
    
    createDesktopTrendingLinks();
    
    var headerBottom = calculateDesktopHeaderBottom();
    var availableHeight = window.innerHeight - headerBottom;
    
    if (searchResultsCarousel) {
      searchResultsCarousel.style.cssText = getSearchPanelCSSAuto(false, headerBottom, availableHeight);
      searchResultsCarousel.classList.add('active');
      searchResultsCarousel.scrollTop = 0;
    }
    
    var desktopTrending = document.getElementById('desktopTrendingSection');
    var desktopLinks = document.getElementById('desktopLinksSection');
    if (desktopTrending) desktopTrending.style.display = 'block';
    if (desktopLinks) desktopLinks.style.display = 'block';
    
    var collectionsCarousel = document.getElementById('searchCollectionsCarousel');
    if (collectionsCarousel) collectionsCarousel.style.setProperty('display', 'none', 'important');
    
    if (searchResultsCarouselInner) searchResultsCarouselInner.innerHTML = '';
    if (searchResultsCount) searchResultsCount.textContent = '';
  }, openDelay);
}

function closeDesktopSearch() {
  desktopSearchActive = false;
  _lastSearchQuery = null;
  
  if (desktopSearchOpenTimer) { clearTimeout(desktopSearchOpenTimer); desktopSearchOpenTimer = null; }
  
  document.body.classList.remove('desktop-search-active');
  
  if (desktopSearchInline) desktopSearchInline.classList.remove('active');
  if (desktopSearchInput) desktopSearchInput.value = '';
  if (searchResultsCarousel) {
    searchResultsCarousel.classList.remove('active');
    searchResultsCarousel.style.display = 'none';
    searchResultsCarousel.style.cssText = '';
  }
  if (searchResultsCarouselInner) searchResultsCarouselInner.innerHTML = '';
  if (searchResultsCount) searchResultsCount.textContent = '';
  
  var desktopTrending = document.getElementById('desktopTrendingSection');
  var desktopLinks = document.getElementById('desktopLinksSection');
  if (desktopTrending) desktopTrending.style.display = 'none';
  if (desktopLinks) desktopLinks.style.display = 'none';
  
  var collectionsCarousel = document.getElementById('searchCollectionsCarousel');
  if (collectionsCarousel) collectionsCarousel.style.removeProperty('display');
  
  if (headerIconsGroup) {
    headerIconsGroup.style.display = 'flex';
    headerIconsGroup.style.opacity = '0';
    setTimeout(function() { headerIconsGroup.style.opacity = '1'; }, 10);
  }
}

if (openSearchBtnDesktop) openSearchBtnDesktop.addEventListener('click', function(e) { e.preventDefault(); openDesktopSearch(); });
if (desktopSearchClose) desktopSearchClose.addEventListener('click', closeDesktopSearch);

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    if (desktopSearchActive) closeDesktopSearch();
    if (mobileSearchActive) closeMobileSearchInline();
  }
});

// ============================================================
// SECCIÓN 7: UTILIDADES
// ============================================================

function masterSrc(url) { 
  if (!url) return '';
  var base = url.split('?')[0]; 
  base = base.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|[0-9]+x[0-9]+|2048x2048|1024x1024)(@2x)?(\.[a-z]+)$/i, '$3'); 
  return base; 
}

/**
 * FIX MONEDA: formateo correcto multi-país usando Intl.NumberFormat
 *
 * - Lee CURRENCY (CLP, EUR, USD, GBP...) y LOCALE (es-CL, es-ES, en-US...) de window.
 * - Aplica conversión vía RATE si los precios base están en otra divisa (EUR base
 *   en el JSON externo → multiplica por RATE para mostrar en moneda local).
 * - Monedas sin decimales (CLP, JPY, KRW, ISK...) se redondean a entero.
 * - Si Intl.NumberFormat falla por algún motivo, cae al formato antiguo solo
 *   para no romper la UI.
 *
 * Acepta tanto un número como un string ("12.99", "12,99", "12,99 €").
 */
function formatShopifyPrice(price) {
  if (price === null || price === undefined || price === '') return '';
  
  var num;
  if (typeof price === 'number') {
    num = price;
  } else {
    var numStr = String(price).replace(/[^0-9.,]/g, '').replace(',', '.');
    num = parseFloat(numStr);
  }
  if (isNaN(num) || num === 0) return '';
  
  // Aplicar tasa de cambio si el precio base está en otra divisa
  // (RATE viene de Shopify localization → es 1.0 si la moneda base ya es la del país)
  var converted = num * RATE;
  // Euros: siempre "72,00€" (mismo formato que el resto de la tienda), sea cual sea el idioma.
  if (CURRENCY === 'EUR' && window.yxFormatPrice) return window.yxFormatPrice(converted);

  try {
    return new Intl.NumberFormat(LOCALE, {
      style: 'currency',
      currency: CURRENCY,
      minimumFractionDigits: isZeroDecimal ? 0 : 2,
      maximumFractionDigits: isZeroDecimal ? 0 : 2
    }).format(converted);
  } catch(e) {
    // Fallback solo si Intl falla
    if (CURRENCY === 'EUR') return converted.toFixed(2).replace('.', ',') + '€';
    return converted.toFixed(2) + ' ' + CURRENCY;
  }
}

function parseSearchHexData(s) {
  if (!s) return [];
  return s.split(';;;').map(function(e) {
    var p = e.trim().split('|||');
    return { hex: (p[0]||'').trim(), url: (p[1]||'').trim(), image: (p[2]||'').trim(), title: (p[3]||'').trim(), priceStr: (p[4]||'').trim(), compareStr: (p[5]||'').trim(), priceNum: parseFloat(p[6])||0, compareNum: parseFloat(p[7])||0 };
  }).filter(function(p) { return p.hex && p.hex.startsWith('#'); });
}

function toTitleCase(str) { return (str || '').toLowerCase().replace(/\b\w/g, function(c) { return c.toUpperCase(); }); }

// ============================================================
// SECCIÓN 8: DICCIONARIOS
// ============================================================

const colorMap = {
  'rosa': 'PINK', 'pink': 'PINK', 'rosado': 'PINK', 'fucsia': 'PINK', 'fuchsia': 'PINK', 'salmon': 'PINK', 'salmón': 'PINK', 'salomon': 'PINK',
  'azul': 'BLUE', 'blue': 'BLUE', 'celeste': 'BLUE', 'navy': 'NAVY', 'marino': 'NAVY', 'azulmarino': 'NAVY',
  'negro': 'BLACK', 'black': 'BLACK', 'negra': 'BLACK', 'oscuro': 'BLACK', 'dark': 'BLACK',
  'blanco': 'WHITE', 'white': 'WHITE', 'blanca': 'WHITE', 'crudo': 'WHITE', 'hueso': 'WHITE', 'ivory': 'WHITE', 'offwhite': 'WHITE', 'marfil': 'WHITE',
  'rojo': 'RED', 'red': 'RED', 'roja': 'RED', 'cereza': 'RED', 'cherry': 'RED', 'escarlata': 'RED',
  'verde': 'GREEN', 'green': 'GREEN', 'oliva': 'GREEN', 'olive': 'GREEN', 'militar': 'GREEN', 'musgo': 'GREEN', 'menta': 'GREEN', 'mint': 'GREEN', 'esmeralda': 'GREEN', 'emerald': 'GREEN', 'lima': 'GREEN', 'lime': 'GREEN',
  'gris': 'GREY', 'grey': 'GREY', 'gray': 'GREY', 'plomo': 'GREY', 'marengo': 'GREY', 'charcoal': 'GREY', 'antracita': 'GREY', 'anthracite': 'GREY',
  'marron': 'BROWN', 'marrón': 'BROWN', 'brown': 'BROWN', 'chocolate': 'BROWN', 'cafe': 'BROWN', 'café': 'BROWN', 'camel': 'BROWN', 'tabaco': 'BROWN', 'tobacco': 'BROWN', 'tierra': 'BROWN', 'tostado': 'BROWN', 'tan': 'BROWN', 'cognac': 'BROWN',
  'beige': 'BEIGE', 'crema': 'CREAM', 'cream': 'CREAM', 'arena': 'BEIGE', 'sand': 'BEIGE', 'vainilla': 'BEIGE', 'vanilla': 'BEIGE', 'champagne': 'BEIGE', 'champán': 'BEIGE',
  'naranja': 'ORANGE', 'orange': 'ORANGE', 'coral': 'ORANGE', 'melocotón': 'ORANGE', 'peach': 'ORANGE', 'terracota': 'ORANGE', 'terracotta': 'ORANGE', 'teja': 'ORANGE', 'rust': 'ORANGE', 'óxido': 'ORANGE',
  'amarillo': 'YELLOW', 'yellow': 'YELLOW', 'mostaza': 'YELLOW', 'mustard': 'YELLOW', 'dorado': 'YELLOW', 'gold': 'YELLOW', 'oro': 'YELLOW',
  'morado': 'PURPLE', 'purple': 'PURPLE', 'violeta': 'PURPLE', 'lila': 'PURPLE', 'lilac': 'PURPLE', 'malva': 'PURPLE', 'mauve': 'PURPLE', 'ciruela': 'PURPLE', 'plum': 'PURPLE',
  'burdeos': 'BURGUNDY', 'burgundy': 'BURGUNDY', 'granate': 'BURGUNDY', 'vino': 'BURGUNDY', 'wine': 'BURGUNDY', 'borgoña': 'BURGUNDY',
  'lavanda': 'LAVENDER', 'lavender': 'LAVENDER',
  'turquesa': 'BLUE', 'turquoise': 'BLUE', 'cyan': 'BLUE', 'aqua': 'BLUE', 'aguamarina': 'BLUE',
  'kaki': 'GREEN', 'khaki': 'GREEN', 'caqui': 'GREEN',
  'plateado': 'GREY', 'silver': 'GREY', 'plata': 'GREY'
};

const typeMap = {
  'sudadera': ['hoodie', 'hoodies'], 'sudaderas': ['hoodie', 'hoodies'],
  'hoodie': ['hoodie', 'hoodies'], 'hoodies': ['hoodie', 'hoodies'],
  'camiseta': ['t-shirt', 'tee', 'longsleeve'], 'camisetas': ['t-shirt', 'tee', 'longsleeve'],
  'tshirt': ['t-shirt', 'tee'], 't-shirt': ['t-shirt', 'tee'], 'tee': ['t-shirt', 'tee'], 'tees': ['t-shirt', 'tee'],
  'longsleeve': ['longsleeve'], 'longsleeves': ['longsleeve'], 'mangalarga': ['longsleeve'],
  'crewneck': ['crewneck', 'crew'], 'crewnecks': ['crewneck', 'crew'],
  'polo': ['polo'], 'polos': ['polo'],
  'camisa': ['shirt'], 'camisas': ['shirt'], 'shirt': ['shirt'], 'shirts': ['shirt'],
  'pantalon': ['pants', 'pant', 'trouser'], 'pantalones': ['pants', 'pant', 'trouser'],
  'pantalón': ['pants', 'pant', 'trouser'], 'pants': ['pants', 'pant'], 'pant': ['pants', 'pant'],
  'trouser': ['trouser', 'pants'], 'trousers': ['trouser', 'pants'],
  'vaquero': ['jean', 'jeans', 'denim'], 'vaqueros': ['jean', 'jeans', 'denim'],
  'jean': ['jean', 'jeans', 'denim'], 'jeans': ['jean', 'jeans', 'denim'],
  'denim': ['jean', 'jeans', 'denim'], 'tejano': ['jean', 'jeans', 'denim'], 'tejanos': ['jean', 'jeans', 'denim'],
  'short': ['short', 'shorts'], 'shorts': ['short', 'shorts'],
  'bermuda': ['bermuda', 'short', 'shorts'], 'bermudas': ['bermuda', 'short', 'shorts'],
  'bañador': ['swimshort', 'swimshorts', 'swim'], 'bañadores': ['swimshort', 'swimshorts', 'swim'],
  'banador': ['swimshort', 'swimshorts', 'swim'], 'banadores': ['swimshort', 'swimshorts', 'swim'],
  'swimshort': ['swimshort', 'swimshorts', 'swim'], 'swimshorts': ['swimshort', 'swimshorts', 'swim'],
  'swim': ['swimshort', 'swimshorts', 'swim'], 'swimwear': ['swimshort', 'swimshorts', 'swim'],
  'baño': ['swimshort', 'swimshorts', 'swim'], 'bano': ['swimshort', 'swimshorts', 'swim'],
  'chaqueta': ['jacket', 'coat'], 'chaquetas': ['jacket', 'coat'],
  'jacket': ['jacket'], 'jackets': ['jacket'],
  'abrigo': ['coat', 'jacket', 'outerwear'], 'abrigos': ['coat', 'jacket', 'outerwear'],
  'coat': ['coat', 'jacket'], 'coats': ['coat', 'jacket'],
  'cazadora': ['bomber', 'jacket'], 'cazadoras': ['bomber', 'jacket'],
  'bomber': ['bomber', 'jacket'], 'bombers': ['bomber', 'jacket'],
  'parka': ['parka', 'jacket', 'outerwear'], 'parkas': ['parka', 'jacket', 'outerwear'],
  'trench': ['trench', 'jacket', 'outerwear'], 'gabardina': ['trench', 'jacket', 'outerwear'],
  'chubasquero': ['raincoat', 'rain', 'jacket', 'waterproof'], 'impermeable': ['raincoat', 'rain', 'jacket', 'waterproof'],
  'raincoat': ['raincoat', 'rain', 'jacket'], 'windbreaker': ['windbreaker', 'jacket'],
  'cortavientos': ['windbreaker', 'jacket'],
  'blazer': ['blazer'], 'blazers': ['blazer'], 'americana': ['blazer'],
  'chaleco': ['vest', 'gilet'], 'chalecos': ['vest', 'gilet'],
  'vest': ['vest', 'gilet'], 'gilet': ['vest', 'gilet'],
  'jersey': ['knit', 'sweater'], 'jerseys': ['knit', 'sweater'], 'jerseis': ['knit', 'sweater'],
  'sweater': ['knit', 'sweater'], 'punto': ['knit', 'sweater'],
  'knit': ['knit', 'sweater'], 'knitwear': ['knit', 'sweater'],
  'cardigan': ['cardigan', 'knit'], 'cárdigan': ['cardigan', 'knit'], 'cardigans': ['cardigan', 'knit'], 'rebeca': ['cardigan', 'knit'],
  'zip': ['zip', 'half-zip', 'halfzip'], 'halfzip': ['zip', 'half-zip', 'halfzip'],
  'cremallera': ['zip', 'half-zip'],
  'lino': ['linen'], 'linen': ['linen'],
  'jogger': ['jogger', 'joggers', 'tracksuit'], 'joggers': ['jogger', 'joggers', 'tracksuit'],
  'chandal': ['tracksuit', 'jogger'], 'chándal': ['tracksuit', 'jogger'],
  'tracksuit': ['tracksuit', 'jogger'],
  'cinturon': ['belt', 'belts'], 'cinturón': ['belt', 'belts'], 'cinturones': ['belt', 'belts'],
  'belt': ['belt', 'belts'], 'belts': ['belt', 'belts'],
  'bolso': ['bag', 'tote'], 'bolsa': ['bag', 'tote'], 'bolsos': ['bag', 'tote'], 'bolsas': ['bag', 'tote'],
  'bag': ['bag', 'tote'], 'bags': ['bag', 'tote'], 'tote': ['tote', 'bag'],
  'mochila': ['backpack', 'bag'], 'mochilas': ['backpack', 'bag'], 'backpack': ['backpack', 'bag'],
  'riñonera': ['belt bag', 'fanny', 'bag'], 'rinonera': ['belt bag', 'fanny', 'bag'],
  'beltbag': ['belt bag', 'fanny', 'bag'], 'fannybag': ['belt bag', 'fanny', 'bag'],
  'neceser': ['pouch', 'toiletry', 'bag'], 'neceseres': ['pouch', 'toiletry', 'bag'],
  'pouch': ['pouch', 'bag'],
  'gorra': ['cap'], 'gorras': ['cap'], 'cap': ['cap'], 'caps': ['cap'],
  'calcetines': ['sock', 'socks'], 'calcetin': ['sock', 'socks'], 'calcetín': ['sock', 'socks'],
  'socks': ['sock', 'socks'], 'sock': ['sock', 'socks'],
  'funda': ['phone case', 'case', 'phone'], 'fundas': ['phone case', 'case', 'phone'],
  'phonecase': ['phone case', 'case', 'phone'], 'case': ['case', 'phone case'],
  'joya': ['jewel', 'jewelry', 'ring', 'necklace', 'bracelet', 'crinkled'],
  'joyas': ['jewel', 'jewelry', 'ring', 'necklace', 'bracelet', 'crinkled'],
  'joyeria': ['jewel', 'jewelry', 'ring', 'necklace', 'bracelet', 'crinkled'],
  'joyería': ['jewel', 'jewelry', 'ring', 'necklace', 'bracelet', 'crinkled'],
  'jewelry': ['jewel', 'jewelry', 'ring', 'necklace', 'bracelet', 'crinkled'],
  'jewellery': ['jewel', 'jewelry', 'ring', 'necklace', 'bracelet', 'crinkled'],
  'anillo': ['ring', 'jewelry', 'crinkled'], 'anillos': ['ring', 'jewelry', 'crinkled'], 'ring': ['ring', 'jewelry', 'crinkled'], 'rings': ['ring', 'jewelry', 'crinkled'],
  'collar': ['necklace', 'jewelry', 'chain', 'crinkled'], 'collares': ['necklace', 'jewelry', 'chain', 'crinkled'], 'necklace': ['necklace', 'jewelry', 'chain', 'crinkled'],
  'pulsera': ['bracelet', 'jewelry', 'crinkled'], 'pulseras': ['bracelet', 'jewelry', 'crinkled'], 'bracelet': ['bracelet', 'jewelry', 'crinkled'],
  'cadena': ['chain', 'necklace', 'crinkled'], 'cadenas': ['chain', 'necklace', 'crinkled'], 'chain': ['chain', 'necklace', 'crinkled'],
  'pendiente': ['earring', 'jewelry', 'crinkled'], 'pendientes': ['earring', 'jewelry', 'crinkled'], 'earring': ['earring', 'jewelry', 'crinkled'], 'earrings': ['earring', 'jewelry', 'crinkled'],
  'zapato': ['shoe', 'footwear'], 'zapatos': ['shoe', 'footwear'],
  'zapatilla': ['sneaker', 'shoe', 'footwear'], 'zapatillas': ['sneaker', 'shoe', 'footwear'],
  'sneaker': ['sneaker', 'shoe', 'footwear'], 'sneakers': ['sneaker', 'shoe', 'footwear'],
  'shoe': ['shoe', 'footwear'], 'shoes': ['shoe', 'footwear'],
  'footwear': ['footwear', 'shoe', 'sneaker'],
  'bota': ['boot', 'footwear'], 'botas': ['boot', 'footwear'], 'boot': ['boot', 'footwear'], 'boots': ['boot', 'footwear'],
  'sandalia': ['sandal', 'footwear'], 'sandalias': ['sandal', 'footwear'], 'sandal': ['sandal', 'footwear'], 'sandals': ['sandal', 'footwear'],
  'chancla': ['flip-flop', 'slide', 'footwear'], 'chanclas': ['flip-flop', 'slide', 'footwear'],
  'slide': ['slide', 'flip-flop', 'footwear'], 'slides': ['slide', 'flip-flop', 'footwear'],
  'mocasin': ['loafer', 'footwear'], 'mocasín': ['loafer', 'footwear'], 'mocasines': ['loafer', 'footwear'],
  'loafer': ['loafer', 'footwear'], 'loafers': ['loafer', 'footwear'],
  'maleta': ['suitcase', 'luggage', 'travel', 'trolley'],
  'maletas': ['suitcase', 'luggage', 'travel', 'trolley'],
  'suitcase': ['suitcase', 'luggage', 'travel', 'trolley'],
  'trolley': ['trolley', 'suitcase', 'luggage', 'travel'],
  'equipaje': ['luggage', 'suitcase', 'travel'],
  'luggage': ['luggage', 'suitcase', 'travel'],
  'gafas': ['sunglasses', 'glasses'], 'gafa': ['sunglasses', 'glasses'],
  'sunglasses': ['sunglasses', 'glasses'], 'glasses': ['glasses', 'sunglasses'],
  'bufanda': ['scarf', 'scarves'], 'bufandas': ['scarf', 'scarves'],
  'pañuelo': ['scarf', 'scarves', 'bandana'], 'panuelo': ['scarf', 'scarves', 'bandana'],
  'scarf': ['scarf', 'scarves'], 'scarves': ['scarf', 'scarves'],
  'llavero': ['keychain', 'key'], 'llaveros': ['keychain', 'key'],
  'keychain': ['keychain', 'key'],
  'toalla': ['towel'], 'toallas': ['towel'], 'towel': ['towel'], 'towels': ['towel'],
  'cartera': ['wallet', 'card holder'], 'billetera': ['wallet', 'card holder'],
  'wallet': ['wallet', 'card holder'], 'tarjetero': ['card holder', 'wallet'],
  'accesorio': ['accessory', 'accessories'], 'accesorios': ['accessory', 'accessories'],
  'accessory': ['accessory', 'accessories'], 'accessories': ['accessory', 'accessories'],
  'top': ['top', 'crop'], 'tops': ['top', 'crop'],
  'crop': ['crop', 'top'], 'croptop': ['crop', 'top'],
  'mujer': ['woman'], 'woman': ['woman'], 'women': ['woman'], 'forher': ['forher'],
  'oversized': ['oversized', 'oversize'], 'oversize': ['oversized', 'oversize'],
  'basico': ['essential', 'basic'], 'básico': ['essential', 'basic'],
  'basicos': ['essential', 'basic'], 'básicos': ['essential', 'basic'],
  'essential': ['essential', 'basic'], 'essentials': ['essential', 'basic']
};

var _typeMapKeys = Object.keys(typeMap);
var _colorMapKeys = Object.keys(colorMap);

function fuzzyTypeMapLookup(word) {
  var norm = normalizeText(word);
  if (norm.length < 3) {
    return typeMap[norm] || null;
  }
  
  if (typeMap[norm]) return typeMap[norm];
  
  var bestScore = 0;
  var bestKey = null;
  var threshold = fuzzyThreshold(norm.length);
  if (threshold === 0) return null;
  
  for (var i = 0; i < _typeMapKeys.length; i++) {
    var key = _typeMapKeys[i];
    var keyNorm = normalizeText(key);
    
    if (norm.length >= 3 && keyNorm.indexOf(norm) === 0) {
      var prefScore = 90;
      if (prefScore > bestScore) { bestScore = prefScore; bestKey = key; }
      continue;
    }
    if (norm.length >= 3 && norm.indexOf(keyNorm) === 0 && keyNorm.length >= 3) {
      var prefScore2 = 75;
      if (prefScore2 > bestScore) { bestScore = prefScore2; bestKey = key; }
      continue;
    }
    
    var dist = levenshtein(norm, keyNorm, threshold);
    if (dist <= threshold) {
      var score = 70 - dist * 15;
      if (score > bestScore) { bestScore = score; bestKey = key; }
    }
  }
  
  return bestKey ? typeMap[bestKey] : null;
}

function fuzzyColorMapLookup(word) {
  var norm = normalizeText(word);
  if (norm.length < 3) {
    return colorMap[norm] || null;
  }
  
  if (colorMap[norm]) return colorMap[norm];
  
  var threshold = fuzzyThreshold(norm.length);
  if (threshold === 0) return null;
  
  for (var i = 0; i < _colorMapKeys.length; i++) {
    var key = _colorMapKeys[i];
    var keyNorm = normalizeText(key);
    if (norm.length >= 4 && keyNorm.indexOf(norm) === 0) return colorMap[key];
    if (norm.length >= 4 && norm.indexOf(keyNorm) === 0 && keyNorm.length >= 3) return colorMap[key];
    var dist = levenshtein(norm, keyNorm, threshold);
    if (dist <= threshold) return colorMap[key];
  }
  return null;
}


const validColorTags = ['PINK', 'BLUE', 'BLACK', 'WHITE', 'RED', 'GREEN', 'GREY', 'GRAY', 'BROWN', 'BEIGE', 'CREAM', 'ORANGE', 'YELLOW', 'PURPLE', 'BURGUNDY', 'NAVY', 'LAVENDER'];

function getCategoryFromTitle(title) {
  var t = title.toLowerCase();
  if (t.indexOf('hoodie') !== -1 || t.indexOf('hoodies') !== -1) return ['hoodie', 'hoodies'];
  if (t.indexOf('crewneck') !== -1 || t.indexOf('crew') !== -1) return ['crewneck', 'crew'];
  if (t.indexOf('longsleeve') !== -1) return ['longsleeve', 't-shirt', 'tee'];
  if (t.indexOf('t-shirt') !== -1 || t.indexOf('tee') !== -1) return ['t-shirt', 'tee', 'longsleeve'];
  if (t.indexOf('polo') !== -1) return ['polo'];
  if (t.indexOf('shirt') !== -1 && t.indexOf('t-shirt') === -1 && t.indexOf('swimshort') === -1) return ['shirt'];
  if (t.indexOf('swimshort') !== -1 || t.indexOf('swim') !== -1) return ['swimshort', 'swimshorts', 'swim'];
  if (t.indexOf('short') !== -1 && t.indexOf('swimshort') === -1) return ['short', 'shorts'];
  if (t.indexOf('bermuda') !== -1) return ['bermuda', 'short', 'shorts'];
  if (t.indexOf('jean') !== -1 || t.indexOf('denim') !== -1) return ['jean', 'jeans', 'denim'];
  if (t.indexOf('jogger') !== -1 || t.indexOf('tracksuit') !== -1) return ['jogger', 'joggers', 'tracksuit'];
  if (t.indexOf('pants') !== -1 || t.indexOf('pant') !== -1 || t.indexOf('trouser') !== -1) return ['pants', 'pant', 'trouser'];
  if (t.indexOf('bomber') !== -1) return ['bomber', 'jacket'];
  if (t.indexOf('parka') !== -1) return ['parka', 'jacket', 'outerwear'];
  if (t.indexOf('trench') !== -1) return ['trench', 'jacket', 'outerwear'];
  if (t.indexOf('blazer') !== -1) return ['blazer'];
  if (t.indexOf('raincoat') !== -1 || t.indexOf('waterproof') !== -1) return ['raincoat', 'rain', 'jacket'];
  if (t.indexOf('windbreaker') !== -1) return ['windbreaker', 'jacket'];
  if (t.indexOf('jacket') !== -1) return ['jacket', 'coat'];
  if (t.indexOf('coat') !== -1) return ['coat', 'jacket'];
  if (t.indexOf('vest') !== -1 || t.indexOf('gilet') !== -1) return ['vest', 'gilet'];
  if (t.indexOf('cardigan') !== -1) return ['cardigan', 'knit'];
  if (t.indexOf('knit') !== -1 || t.indexOf('sweater') !== -1) return ['knit', 'sweater'];
  if (t.indexOf('zip') !== -1) return ['zip', 'half-zip', 'halfzip'];
  if (t.indexOf('linen') !== -1) return ['linen'];
  if (t.indexOf('belt') !== -1 && t.indexOf('belt bag') === -1) return ['belt', 'belts'];
  if (t.indexOf('belt bag') !== -1 || t.indexOf('fanny') !== -1) return ['belt bag', 'fanny', 'bag'];
  if (t.indexOf('backpack') !== -1) return ['backpack', 'bag'];
  if (t.indexOf('bag') !== -1 || t.indexOf('tote') !== -1) return ['bag', 'tote'];
  if (t.indexOf('pouch') !== -1 || t.indexOf('toiletry') !== -1) return ['pouch', 'bag'];
  if (/(^|[\s\-_"])caps?($|[\s\-_"])/.test(t) && t.indexOf('case') === -1) return ['cap'];
  if (t.indexOf('sock') !== -1) return ['sock', 'socks'];
  if (t.indexOf('sandal') !== -1) return ['sandal', 'footwear'];
  if (t.indexOf('slide') !== -1 || t.indexOf('flip-flop') !== -1) return ['slide', 'flip-flop', 'footwear'];
  if (t.indexOf('boot') !== -1) return ['boot', 'footwear'];
  if (t.indexOf('loafer') !== -1 || t.indexOf('mocasin') !== -1) return ['loafer', 'footwear'];
  if (t.indexOf('sneaker') !== -1 || t.indexOf('shoe') !== -1) return ['sneaker', 'shoe', 'footwear'];
  if (t.indexOf('suitcase') !== -1 || t.indexOf('luggage') !== -1 || t.indexOf('maleta') !== -1 || t.indexOf('trolley') !== -1) return ['suitcase', 'luggage', 'travel', 'trolley'];
  if (t.indexOf('ring') !== -1 && t.indexOf('string') === -1) return ['ring', 'jewelry', 'crinkled'];
  if (t.indexOf('necklace') !== -1 || t.indexOf('chain') !== -1) return ['necklace', 'chain', 'jewelry', 'crinkled'];
  if (t.indexOf('bracelet') !== -1) return ['bracelet', 'jewelry', 'crinkled'];
  if (t.indexOf('earring') !== -1) return ['earring', 'jewelry', 'crinkled'];
  if (t.indexOf('jewel') !== -1 || t.indexOf('crinkled') !== -1) return ['jewel', 'jewelry', 'crinkled'];
  if (t.indexOf('scarf') !== -1 || t.indexOf('bandana') !== -1) return ['scarf', 'scarves'];
  if (t.indexOf('wallet') !== -1 || t.indexOf('card holder') !== -1) return ['wallet', 'card holder'];
  if (t.indexOf('keychain') !== -1) return ['keychain', 'key'];
  if (t.indexOf('sunglasses') !== -1 || t.indexOf('glasses') !== -1) return ['sunglasses', 'glasses'];
  if (t.indexOf('towel') !== -1) return ['towel'];
  if (t.indexOf('phone case') !== -1 || t.indexOf('case') !== -1) return ['case', 'phone case'];
  if (t.indexOf('crop') !== -1) return ['crop', 'top'];
  if (t.indexOf('top') !== -1 && t.indexOf('stop') === -1) return ['top', 'crop'];
  if (t.indexOf('woman') !== -1 || t.indexOf('forher') !== -1) return ['woman', 'forher'];
  return [];
}

function getColorFromTags(tags) {
  for (var i = 0; i < tags.length; i++) {
    var tagUpper = tags[i].toUpperCase();
    if (validColorTags.indexOf(tagUpper) !== -1) return tagUpper;
  }
  return null;
}

function isCapSearchIntent(queryWords, searchTypeTerms) {
  if (!searchTypeTerms || searchTypeTerms.indexOf('cap') === -1) return false;
  var capWords = ['gorra', 'gorras', 'cap', 'caps'];
  for (var i = 0; i < queryWords.length; i++) {
    if (capWords.indexOf(queryWords[i]) !== -1) return true;
  }
  return false;
}

function productMatchesCapIntent(idx) {
  if (!idx) return false;
  if (idx.category && idx.category.indexOf('cap') !== -1) return true;
  if (idx.productTypeNorm && (idx.productTypeNorm === 'cap' || idx.productTypeNorm === 'caps')) return true;
  if (idx.tagsUpper && (idx.tagsUpper.indexOf('CAP') !== -1 || idx.tagsUpper.indexOf('CAPS') !== -1)) return true;
  return false;
}

// ============================================================
// SECCIÓN 9: FORMATEO DE PRODUCTOS
// ============================================================

/**
 * FIX MONEDA: reformatea SIEMPRE desde *_num en lugar de usar p.price_str
 * del JSON externo (que viene en EUR hardcodeado).
 */
function formatProductsForDisplay(products) {
  return products.map(function(p) {
    var isCollectionCoreFormat = p.price_str !== undefined || p.images_array !== undefined;
    
    var priceNum = 0, compareNum = 0, images = [];
    
    if (isCollectionCoreFormat) {
      priceNum = parseFloat(p.price_num) || 0;
      compareNum = parseFloat(p.compare_num) || 0;
      if (p.images_array && Array.isArray(p.images_array)) {
        images = p.images_array.filter(function(url) { return url && url !== ''; });
      }
    } else {
      // Precio/rebaja agregados de TODAS las variantes vivas, NO solo variants[0]
      // (que puede ser una talla a precio completo sin rebaja y ocultaba la oferta).
      // Igual que el grid: precio = mínimo de variantes, compare = compare_at_price_max.
      var live = _livePricesFromVariants(p.variants);
      if (live) {
        priceNum = live.price_num;
        compareNum = live.compare_num;
      } else if (p.price) {
        priceNum = parseFloat(String(p.price).replace(/[^0-9.]/g, '')) || 0;
        if (p.compareAtPrice) {
          compareNum = parseFloat(String(p.compareAtPrice).replace(/[^0-9.]/g, '')) || 0;
        }
      }
      
      if (p.images && Array.isArray(p.images) && p.images.length > 0) {
        images = p.images.map(function(img) {
          if (typeof img === 'string') return img;
          if (img && img.src) return img.src;
          if (img && img.url) return img.url;
          return '';
        }).filter(function(url) { return url !== ''; });
      }
      if (images.length === 0 && p.image) {
        if (typeof p.image === 'string') images = [p.image];
        else if (p.image.src) images = [p.image.src];
      }
    }
    
    // FIX MONEDA: formatear siempre con la divisa actual del país
    var price = priceNum > 0 ? formatShopifyPrice(priceNum) : '';
    var comparePrice = compareNum > 0 ? formatShopifyPrice(compareNum) : '';
    
    var formattedVariants = (p.variants || []).map(function(v) {
      return {
        id: v.id,
        title: v.title === 'Default Title' ? 'ONE SIZE' : (v.title || '').toUpperCase(),
        available: v.available !== false,
        inventory_quantity: v.inventory_quantity || v.inventory || 0
      };
    });
    
    var isSoldOut = false;
    if (formattedVariants.length > 0) {
      isSoldOut = formattedVariants.every(function(v) { return !v.available; });
    } else if (p.total_inventory !== undefined) {
      isSoldOut = p.total_inventory <= 0;
    } else if (p.totalInventory !== undefined) {
      isSoldOut = p.totalInventory <= 0;
    }
    
    var url = p.url || ('/products/' + p.handle);
    
    return {
      title: p.title,
      handle: p.handle,
      url: url,
      image: images[0] || '',
      images: images,
      price: price,
      price_num: priceNum,
      compare_price: comparePrice,
      compare_num: compareNum,
      variants: formattedVariants,
      tags: p.tags || [],
      available: p.available !== false && !isSoldOut,
      isSoldOut: isSoldOut,
      salesUnits: p.salesUnits || 0,
      groupTag: p.groupTag || '',
      groupCount: p.groupCount || 0,
      groupHexData: p.groupHexData || ''
    };
  });
}

// ============================================================
// SECCIÓN 10: BADGE DE PRODUCTO
// ============================================================

function getProductBadgeData(product) {
  var variants = product.variants || [];
  var allOut = product.isSoldOut || false;
  if (!allOut && variants.length > 0) allOut = variants.every(function(v) { return !v.available; });
  if (typeof product.available !== 'undefined' && !product.available) allOut = true;
  
  var tagsLower = (product.tags || []).map(function(x) { return x.toLowerCase(); });
  if (tagsLower.indexOf('sold out') !== -1 || tagsLower.indexOf('soldout') !== -1 || tagsLower.indexOf('agotado') !== -1) allOut = true;
  
  var tagsNormalized = tagsLower.map(function(x) { return x.replace(/[\s_-]/g, ''); });
  var hasNewIn = tagsNormalized.some(function(tag) { return tag === 'newin' || tag.indexOf('newin') !== -1; });
  var hasComingSoon = (product.tags || []).indexOf('coming-soon') !== -1;
  var hasBackInStock = tagsNormalized.some(function(tag) { return tag === 'backinstock'; });
  var hasWinterSaleOG = tagsNormalized.some(function(tag) { return tag === 'wintersaleog'; });
  var isInSummerSale = false;
  if (product.collections) isInSummerSale = product.collections.some(function(col) { return col.handle === 'summer-sale' || col.title === 'SUMMER SALE'; });
  if (tagsLower.indexOf('summer-sale') !== -1) isInSummerSale = true;
  
  if (hasComingSoon && allOut) return { class: 'coming-soon', text: T.comingSoon, isOut: false };
  if (allOut) return { class: 'sold-out', text: T.soldOut, isOut: true };
  if (hasWinterSaleOG) return { class: 'winter-sale', text: 'WINTER SALE', isOut: false };
  if (hasBackInStock) return { class: 'back-in-stock', text: 'BACK IN STOCK', isOut: false };
  if (isInSummerSale) return { class: IS_SPAIN ? 'summer-sale' : 'mid-season-sale', text: IS_SPAIN ? T.summerSale : T.midSeasonSale, isOut: false };
  if (hasNewIn) return { class: 'new-in', text: T.newIn, isOut: false };
  
  return null;
}

// ============================================================
// SECCIÓN 11: INTERACCIONES CON PRODUCTOS
// ============================================================

function addToCartFromSearch(variantId, productUrl) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
  })
  .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
  .then(function() { 
    if (window.SLIDECART_OPEN) window.SLIDECART_OPEN(); 
    if (window.SLIDECART_UPDATE) window.SLIDECART_UPDATE(); 
  })
  .catch(function() { window.location.href = productUrl; });
}

function applySearchProductInteractions() {
  document.querySelectorAll('.search-product-slide').forEach(function(card) {
    var imgW = card.querySelector('.search-product-image-wrapper');
    var imgEl = card.querySelector('.search-product-image');
    var plus = card.querySelector('.search-plus-icon');
    var popDiv = card.querySelector('.search-size-popover');
    if (!imgW || imgW.dataset.init || !imgEl) return;
    imgW.dataset.init = 'true';

    var displayImgs = JSON.parse(imgW.dataset.images || '[]');
    var isMobileView = window.innerWidth <= 768;
    
    imgEl.addEventListener('load', function() { imgEl.classList.add('loaded'); });
    
    var changeImage = function(newSrc) {
      if (imgEl.src === newSrc) return;
      imgEl.classList.remove('loaded');
      imgEl.src = newSrc;
      if (imgEl.complete) imgEl.classList.add('loaded');
    };

    if (displayImgs.length > 1 && !isMobileView) {
      imgW.addEventListener('mouseenter', function() {
        if (imgW.dataset.swappedImage) return;
        imgW.dataset.currentIndex = '1';
        changeImage(displayImgs[1]);
      });
      imgW.addEventListener('mouseleave', function() {
        if (imgW.dataset.swappedImage) { changeImage(imgW.dataset.swappedImage); return; }
        var idx = parseInt(imgW.dataset.currentIndex || 0);
        if (idx === 1) { imgW.dataset.currentIndex = '0'; changeImage(displayImgs[0]); }
      });
    }

    var updateArrow = function(back) {
      if (imgW.dataset.swappedImage) { window.location.href = imgW.getAttribute('href'); return; }
      var idx = parseInt(imgW.dataset.currentIndex || 0);
      idx = back ? (idx - 1 + displayImgs.length) % displayImgs.length : (idx + 1) % displayImgs.length;
      imgW.dataset.currentIndex = idx;
      changeImage(displayImgs[idx]);
      var ind = imgW.querySelector('.search-slide-indicator');
      if (ind && displayImgs.length === 4) ind.style.left = (idx * 25) + '%';
    };
    var arrowL = imgW.querySelector('.search-arrow-inline.arrow-left');
    var arrowR = imgW.querySelector('.search-arrow-inline.arrow-right');
    if (arrowL) arrowL.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); updateArrow(true); });
    if (arrowR) arrowR.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); updateArrow(false); });

    if (plus && popDiv) {
      var openPop = function() { popDiv.classList.add('active'); plus.classList.add('open'); };
      var closePop = function() { popDiv.classList.remove('active'); plus.classList.remove('open'); };
      plus.addEventListener('mouseenter', function() { if (!isMobileView) openPop(); });
      plus.addEventListener('mouseleave', function() { if (!isMobileView) setTimeout(function() { if (!popDiv.matches(':hover')) closePop(); }, 100); });
      plus.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); popDiv.classList.contains('active') ? closePop() : openPop(); });
      popDiv.addEventListener('mouseleave', function() { if (!isMobileView) closePop(); });
      popDiv.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var t = e.target;
        if (!t.classList.contains('search-size-option')) return;
        if (t.classList.contains('out-of-stock')) { window.location.href = t.dataset.productUrl; }
        else { addToCartFromSearch(t.dataset.variantId, t.dataset.productUrl); }
      }, true);
    }

    var notifyBtn = imgW.querySelector('.search-notify-me-btn');
    if (notifyBtn) notifyBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); var url = e.target.dataset.url; if (url) window.location.href = url; });

    if (isMobileView && displayImgs.length > 1) {
      var startX = 0, isDragging = false;
      imgW.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; isDragging = true; }, { passive: true });
      imgW.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        if (!imgW.dataset.swappedImage) { var delta = e.changedTouches[0].clientX - startX; if (Math.abs(delta) > 50) updateArrow(delta > 0); }
        isDragging = false;
      }, { passive: true });
    }

    card.querySelectorAll('.search-hex-bubble[data-bubble-index]').forEach(function(bubble) {
      bubble.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); handleSearchBubbleSwap(this, card); });
    });

    // Metafield product_swatches vía endpoint Liquid: rellena las bolitas si no hay, y manda sobre las del tag Group_ si las hay.
    maybeEnrichCardSwatches(card);
  });
}

function applySearchWishlistLogic() {
  var stored = JSON.parse(localStorage.getItem('wishlist') || '[]');
  document.querySelectorAll('.search-wishlist-button:not([data-init])').forEach(function(btn) {
    btn.dataset.init = 'true';
    var handle = btn.dataset.handle;
    if (stored.some(function(x) { return x.handle === handle; })) btn.classList.add('active');
    btn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      var active = btn.classList.contains('active');
      if (active) { stored = stored.filter(function(x) { return x.handle !== handle; }); btn.classList.remove('active'); }
      else { stored.push({ handle: handle, url: btn.dataset.productUrl, title: btn.dataset.productTitle, image: btn.dataset.productImage }); btn.classList.add('active'); }
      localStorage.setItem('wishlist', JSON.stringify(stored));
    });
  });
}

// ============================================================
// SECCIÓN 12: RENDERIZADO DE PRODUCTOS
// ============================================================

function renderSearchColorBubbles(prod) {
  var hexData = prod.groupHexData || '';
  var groupCount = parseInt(prod.groupCount) || 0;
  if (groupCount <= 1 || !hexData) return '';
  var pairs = parseSearchHexData(hexData);
  var currentIdx = pairs.findIndex(function(p) { return p.url === prod.url; });
  if (currentIdx > 0) { var current = pairs.splice(currentIdx, 1)[0]; pairs.unshift(current); }
  if (pairs.length < 2) {
    return '<span class="search-color-info">' + groupCount + ' ' + T.colours + '</span>';
  }
  pairs.forEach(function(p) { if (p.image) { var img = new Image(); img.src = p.image; } });
  var bubblesJson = JSON.stringify(pairs).replace(/'/g, '&#39;').replace(/"/g, '&quot;');
  var html = '<span class="search-hex-bubbles" data-bubbles-json="' + bubblesJson + '">';
  pairs.forEach(function(p, i) {
    var isActive = p.url === prod.url;
    html += '<span class="search-hex-bubble' + (isActive ? ' active' : '') + '" style="background-color:' + p.hex + '" data-bubble-index="' + i + '"></span>';
  });
  html += '</span>';
  return html;
}

// ============================================================
// SWATCHES POR METAFIELD (custom.product_swatches) EN EL BUSCADOR
// El dataset del buscador (products.json / feed externo) NO trae metafields,
// así que las bolitas por metafield (productos SIN tag Group_) no se pueden
// construir client-side. Para esos, pedimos el endpoint Liquid diminuto
// /products/<handle>?view=swatch-json (snippet 'swatch-hex-data', mismo formato
// ;;;/||| que el grupo) solo para los resultados sin grupo, con caché +/-.
// ============================================================
var _swatchFetchCache = {};      // "handle|view" -> hexData string ('' = sin swatches)
var _swatchInFlight = 0;
var _swatchQueue = [];
var SWATCH_MAX_CONCURRENT = 6;

function _swatchPump() {
  while (_swatchInFlight < SWATCH_MAX_CONCURRENT && _swatchQueue.length) {
    var job = _swatchQueue.shift();
    _swatchInFlight++;
    job();
  }
}

// mfOnly = pedir la vista que devuelve SOLO el metafield (vacío si no lo tiene). Se usa en
// cards que ya traen bolitas del tag: así el metafield hace override y, si no hay, no se toca.
function fetchSwatchData(handle, mfOnly) {
  var view = mfOnly ? 'swatch-json-mf' : 'swatch-json';
  var key = handle + '|' + view;
  if (Object.prototype.hasOwnProperty.call(_swatchFetchCache, key)) {
    return Promise.resolve(_swatchFetchCache[key]);
  }
  return new Promise(function(resolve) {
    _swatchQueue.push(function() {
      fetch('/products/' + encodeURIComponent(handle) + '?view=' + view)
        .then(function(r) { return r.ok ? r.text() : ''; })
        .then(function(t) { t = (t || '').trim(); _swatchFetchCache[key] = t; resolve(t); })
        .catch(function() { _swatchFetchCache[key] = ''; resolve(''); })
        .then(function() { _swatchInFlight--; _swatchPump(); });
    });
    _swatchPump();
  });
}

function buildSearchBubblesHtml(pairs, currentUrl) {
  pairs.forEach(function(p) { if (p.image) { var img = new Image(); img.src = p.image; } });
  var bubblesJson = JSON.stringify(pairs).replace(/'/g, '&#39;').replace(/"/g, '&quot;');
  var html = '<span class="search-hex-bubbles" data-bubbles-json="' + bubblesJson + '">';
  pairs.forEach(function(p, i) {
    var isActive = p.url === currentUrl;
    html += '<span class="search-hex-bubble' + (isActive ? ' active' : '') + '" style="background-color:' + p.hex + '" data-bubble-index="' + i + '"></span>';
  });
  html += '</span>';
  return html;
}

// El metafield custom.product_swatches MANDA sobre el tag Group_, igual que en las cards
// Liquid (snippet swatch-hex-data). Aquí no tenemos metafields en el dataset, así que
// pedimos el endpoint TAMBIÉN para cards que ya traen bolitas del grupo y, si el metafield
// contesta, sustituimos las del grupo.
// Se pide para cada card renderizada (solo las del batch visible, ~10), con caché por
// handle+vista y tope de 6 concurrentes. Para cards que ya traen bolitas se usa la vista
// -mf, que responde vacío si el producto no tiene metafield: así no se toca nada.
function maybeEnrichCardSwatches(card) {
  if (!card || card.dataset.swatchEnriched) return;
  card.dataset.swatchEnriched = 'true';
  var wb = card.querySelector('.search-wishlist-button[data-handle]');
  var handle = wb && wb.dataset.handle;
  if (!handle) return;
  var mainLink = card.querySelector('.search-product-image-wrapper');
  var currentUrl = mainLink ? mainLink.getAttribute('href') : '';
  var hasGroupBubbles = !!card.querySelector('.search-hex-bubbles');
  fetchSwatchData(handle, hasGroupBubbles).then(function(hexData) {
    if (!hexData) return;
    var pairs = parseSearchHexData(hexData);
    if (pairs.length < 2) return;
    var ci = -1;
    for (var i = 0; i < pairs.length; i++) { if (pairs[i].url === currentUrl) { ci = i; break; } }
    if (ci > 0) { pairs.unshift(pairs.splice(ci, 1)[0]); }
    var row = card.querySelector('.search-title-price-row');
    if (!row) return;
    var secondRow = row.querySelector('.search-price-second-row');
    if (!secondRow) { secondRow = document.createElement('div'); secondRow.className = 'search-price-second-row'; row.appendChild(secondRow); }
    // gana el metafield: fuera lo que hubiese montado el tag Group_ (bolitas o contador "N Colores")
    var oldBubbles = secondRow.querySelector('.search-hex-bubbles'); if (oldBubbles) oldBubbles.remove();
    var oldInfo = secondRow.querySelector('.search-color-info'); if (oldInfo) oldInfo.remove();
    secondRow.insertAdjacentHTML('afterbegin', buildSearchBubblesHtml(pairs, currentUrl));
    secondRow.querySelectorAll('.search-hex-bubble[data-bubble-index]').forEach(function(bubble) {
      bubble.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); handleSearchBubbleSwap(this, card); });
    });
  });
}

function handleSearchBubbleSwap(bubble, card) {
  var container = bubble.closest('.search-hex-bubbles');
  if (!container) return;
  var bubblesData;
  try { bubblesData = JSON.parse(container.dataset.bubblesJson); } catch(e) { return; }
  var idx = parseInt(bubble.dataset.bubbleIndex);
  var data = bubblesData[idx];
  if (!data) return;
  container.querySelectorAll('.search-hex-bubble').forEach(function(b) { b.classList.remove('active'); });
  bubble.classList.add('active');
  var imgW = card.querySelector('.search-product-image-wrapper');
  var imgEl = card.querySelector('.search-product-image');
  if (imgEl && data.image) { imgEl.src = data.image; imgEl.classList.add('loaded'); if (imgW) imgW.dataset.swappedImage = data.image; }
  var titleEl = card.querySelector('.search-product-title');
  if (titleEl && data.title) titleEl.textContent = toTitleCase(data.title);
  var priceEl = card.querySelector('.search-product-price');
  if (priceEl) {
    if (data.compareNum > data.priceNum && data.compareNum > 0) { priceEl.innerHTML = '<span class="current-price">' + data.priceStr + '</span><span class="compare-price">' + data.compareStr + '</span>'; }
    else { priceEl.textContent = data.priceStr; }
  }
  var staleCompare = card.querySelector('.search-price-second-row .compare-price'); if (staleCompare) staleCompare.remove();
  card.querySelectorAll('a[href]').forEach(function(a) { a.setAttribute('href', data.url); });
  if (imgW && imgW.tagName === 'A') imgW.setAttribute('href', data.url);
}

function renderSearchProductCard(p) {
  var isMobileView = window.innerWidth <= 768;
  var displayImgs = p.images || [];
  if (displayImgs.length === 0 && p.image) displayImgs = [p.image];
  if (isMobileView && displayImgs.length > 4) displayImgs = displayImgs.slice(0, 4);
  
  var firstImg = displayImgs[0] || '';
  var variants = p.variants || [];
  var allOut = p.isSoldOut || false;
  
  var priceNum = parseFloat(p.price_num) || 0;
  var compareNum = parseFloat(p.compare_num) || 0;
  var priceHTML = compareNum > priceNum
    ? '<span class="current-price">' + p.price + '</span><span class="compare-price">' + p.compare_price + '</span>'
    : p.price;

  var colorInfoHTML = renderSearchColorBubbles(p);
  var secondRowHTML = colorInfoHTML
    ? '<div class="search-price-second-row">' + colorInfoHTML + '</div>'
    : '';

  var badge = getProductBadgeData(p);
  var badgeHTML = '';
  if (badge) badgeHTML = '<div class="search-status-badge ' + badge.class + '">' + badge.text + '</div>';

  var sizePopoverHTML = '';
  if (!allOut && variants.length > 0) {
    sizePopoverHTML = '<div class="search-size-popover"><div class="search-size-popover-scroll"><div class="search-size-popover-inner">' +
      variants.map(function(v) {
        return '<div class="search-size-option ' + (v.available ? '' : 'out-of-stock') + '" data-variant-id="' + v.id + '" data-product-url="' + p.url + '">' + v.title + '</div>';
      }).join('') + '</div></div></div>';
  }

  var notifyMeHTML = allOut 
    ? '<button type="button" class="search-notify-me-btn" data-url="' + p.url + '">Notify Me</button>' 
    : '';

  var indicatorHTML = displayImgs.length === 4 ? '<div class="search-slide-indicator ' + (isMobileView ? 'mobile-4' : '') + '"></div>' : '';

  var escapedTitle = (p.title || '').replace(/"/g, '&quot;');

  return '<div class="search-product-slide">' +
    '<a href="' + p.url + '" class="search-product-image-wrapper ' + (allOut ? 'sold-out' : '') + '"' +
    ' data-images=\'' + JSON.stringify(displayImgs) + '\'' +
    ' data-current-index="0">' +
    '<img src="' + firstImg + '" alt="' + escapedTitle + '" class="search-product-image" decoding="async" onload="this.classList.add(\'loaded\')">' +
    notifyMeHTML +
    '<div class="search-arrow-container">' +
    '<div class="search-arrow-inline arrow-left">&#10094;</div>' +
    '<div class="search-arrow-inline arrow-right">&#10095;</div>' +
    '</div>' +
    '<button type="button" class="search-wishlist-button" data-handle="' + p.handle + '" data-product-url="' + p.url + '" data-product-title="' + escapedTitle + '" data-product-image="' + firstImg + '">' +
    '<svg class="wishlist-icon--empty" style="width:18px;height:18px" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2"><path d="M19 21l-7-5-7 5V5c0-1.108.892-2 2-2h10c1.108 0 2 .892 2 2z"/></svg>' +
    '<svg class="wishlist-icon--full" style="width:18px;height:18px" viewBox="0 0 24 24" fill="#000"><path d="M17 3H7C5.9 3 5 3.9 5 5v16l7-5.14L19 21V5c0-1.1-.9-2-2-2z"/></svg>' +
    '</button>' +
    badgeHTML + indicatorHTML +
    (!allOut ? '<div class="search-plus-icon">+</div>' : '') +
    sizePopoverHTML +
    '</a>' +
    '<div class="search-product-info">' +
    '<a href="' + p.url + '">' +
    '<div class="search-title-price-row">' +
    '<div class="search-product-title">' + toTitleCase(p.title) + '</div>' +
    '<div class="search-product-price">' + priceHTML + '</div>' +
    secondRowHTML +
    '</div></a></div></div>';
}

function preloadSearchImages(products) {
  products.slice(0, 15).forEach(function(p) { if (p.image) { var img = new Image(); img.src = p.image; } });
  setTimeout(function() {
    products.slice(15, 30).forEach(function(p) { if (p.image) { var img = new Image(); img.src = p.image; } });
  }, 300);
}

// ============================================================
// SECCIÓN 13: RENDER PROGRESIVO
// ============================================================

var FIRST_BATCH = 10;

function renderProgressiveProducts(products, query, container, countEl, carouselEl, isMobile) {
  if (!container || !carouselEl) return;
  
  var trendingSection = document.getElementById(isMobile ? 'searchTrendingSection' : 'desktopTrendingSection');
  var linksSection = document.getElementById(isMobile ? 'searchLinksSection' : 'desktopLinksSection');
  
  if (!products.length) {
    var stillLoading = !productsLoaded && (productsPromise || !allProductsCache);
    if (stillLoading) {
      container.innerHTML = '<div class="search-results-message">' + T.searching + '</div>';
    } else {
      try {
        var queryLower = (query || '').toLowerCase().trim();
        if (queryLower.length >= 3 && _mergedDataset && _mergedDataset.length > 0) {
          var foundInDataset = [];
          for (var d = 0; d < _mergedDataset.length && foundInDataset.length < 3; d++) {
            var dp = _mergedDataset[d];
            var hay = ((dp.title || '') + ' ' + (dp.handle || '')).toLowerCase();
            if (hay.indexOf(queryLower) !== -1) {
              foundInDataset.push(dp.title || dp.handle);
            }
          }
          if (foundInDataset.length > 0 && window.console && window.console.warn) {
            console.warn('[YUXUS_SEARCH] Producto existe en dataset pero matching falló:', foundInDataset, '— ejecuta YUXUS_SEARCH_DEBUG.findProduct("' + queryLower + '") en consola');
          }
        }
      } catch(e) {}
      
      container.innerHTML = '<div class="search-results-message">' + T.noProducts + '</div>';
    }
    carouselEl.classList.add('active');
    if (trendingSection) trendingSection.classList.add('active');
    if (linksSection) linksSection.classList.add('active');
    
    if (countEl) {
      if (stillLoading) {
        countEl.textContent = '';
      } else {
        countEl.textContent = query ? '0 ' + T.resultsFor + ' "' + query + '"' : '';
      }
    }
    return;
  }

  if (trendingSection) trendingSection.classList.remove('active');
  if (linksSection) linksSection.classList.remove('active');

  if (countEl) countEl.textContent = query ? products.length + ' ' + T.resultsFor + ' "' + query + '"' : '';

  preloadSearchImages(products);

  var firstBatch = products.slice(0, FIRST_BATCH);
  var html = '';
  for (var i = 0; i < firstBatch.length; i++) html += renderSearchProductCard(firstBatch[i]);
  
  container.innerHTML = html;
  carouselEl.classList.add('active');
  
  requestAnimationFrame(function() {
    applySearchProductInteractions();
    applySearchWishlistLogic();
  });
  
  if (products.length > FIRST_BATCH) {
    var remaining = products.slice(FIRST_BATCH);
    requestAnimationFrame(function() {
      var html2 = '';
      for (var j = 0; j < remaining.length; j++) html2 += renderSearchProductCard(remaining[j]);
      container.insertAdjacentHTML('beforeend', html2);
      
      requestAnimationFrame(function() {
        applySearchProductInteractions();
        applySearchWishlistLogic();
      });
    });
  }
}


// ============================================================
// SECCIÓN 15: BÚSQUEDA PRINCIPAL
// ============================================================

let _searchRequestId = 0;

async function performSearch(q, isMobile) {
  if (!q) return;
  
  var myRequestId = ++_searchRequestId;
  
  var trendingSection = document.getElementById('searchTrendingSection');
  var linksSection = document.getElementById('searchLinksSection');
  if (trendingSection) trendingSection.classList.remove('active');
  if (linksSection) linksSection.classList.remove('active');
  
  var TARGET_PRODUCTS = 50;
  var resultsInner = isMobile ? mobileSearchResultsInner : searchResultsCarouselInner;
  var resultsCarousel = isMobile ? mobileSearchResultsCarousel : searchResultsCarousel;
  var resultsCount = isMobile ? mobileSearchResultsCount : searchResultsCount;
  
  if (resultsInner) resultsInner.innerHTML = '<div class="search-results-message">' + T.searching + '</div>';
  if (resultsCount) resultsCount.textContent = '';
  
  if (isMobile && mobileSearchResultsCarousel) {
    var hb = calculateMobileHeaderBottom();
    var ah = window.innerHeight - hb;
    mobileSearchResultsCarousel.style.cssText = getSearchPanelCSS(true, hb, ah);
    mobileSearchResultsCarousel.classList.add('active');
    mobileSearchResultsCarousel.scrollTop = 0;
  } else if (resultsCarousel) {
    var hbd = calculateDesktopHeaderBottom();
    var ahd = window.innerHeight - hbd;
    resultsCarousel.style.cssText = getSearchPanelCSS(false, hbd, ahd);
    resultsCarousel.classList.add('active');
    resultsCarousel.scrollTop = 0;
  }
  
  try {
    var queryNorm = normalizeText(q);
    var queryWords = queryNorm.split(/\s+/).filter(function(w) { return w.length > 1; });
    
    var cacheKey = queryNorm;
    if (searchCache.has(cacheKey)) {
      if (myRequestId !== _searchRequestId) return;
      var cached = searchCache.get(cacheKey);
      renderProgressiveProducts(cached, q, resultsInner, resultsCount, resultsCarousel, isMobile);
      return;
    }
    
    if (!searchReady) {
      await Promise.race([
        searchReadyPromise,
        new Promise(function(r) { setTimeout(r, 8000); })
      ]);
    }
    
    if (myRequestId !== _searchRequestId) return;
    
    _lastSearchQuery = q;
    _lastSearchIsMobile = isMobile;
    
    var allProductsRaw = [];
    
    if (allProductsCache && allProductsCache.length > 0) {
      allProductsRaw = buildMergedDataset();
    } else if (salesDataCache && salesDataCache.products && salesDataCache.products.length > 0) {
      allProductsRaw = filterByMarket(salesDataCache.products);
      preloadProducts();
    } else {
      await getAllProducts();
      if (myRequestId !== _searchRequestId) return;
      allProductsRaw = buildMergedDataset();
    }
    
    if (allProductsRaw.length === 0) {
      if (resultsInner) resultsInner.innerHTML = '<div class="search-results-message">' + T.noProducts + '</div>';
      return;
    }
    
    if (!searchIndex || searchIndex.length !== allProductsRaw.length) {
      buildSearchIndex(allProductsRaw, true);
    }
    
    var searchColor = null;
    var searchTypeTerms = [];
    
    for (var wi = 0; wi < queryWords.length; wi++) {
      var word = queryWords[wi];
      if (!searchColor) {
        var colorResult = fuzzyColorMapLookup(word);
        if (colorResult) searchColor = colorResult;
      }
      if (searchTypeTerms.length === 0) {
        var typeResult = fuzzyTypeMapLookup(word);
        if (typeResult) searchTypeTerms = typeResult;
      }
    }
    var capSearchIntent = isCapSearchIntent(queryWords, searchTypeTerms);
    
    var searchGroup = null;
    for (var pi = 0; pi < allProductsRaw.length; pi++) {
      var pIdx = searchIndex[pi];
      if (!pIdx) continue;
      if (pIdx.titleNorm.indexOf(queryNorm) !== -1) {
        for (var tgi = 0; tgi < pIdx.tags.length; tgi++) {
          if (pIdx.tags[tgi].toUpperCase().indexOf('GROUP_') === 0) {
            searchGroup = pIdx.tags[tgi].toUpperCase();
            break;
          }
        }
        if (pIdx.color) searchColor = pIdx.color;
        if (searchTypeTerms.length === 0) searchTypeTerms = pIdx.category;
        break;
      }
    }
    
    var scoredProducts = new Array(allProductsRaw.length);
    
    for (var si = 0; si < allProductsRaw.length; si++) {
      var idx = searchIndex[si];
      if (!idx) { scoredProducts[si] = null; continue; }
      if (capSearchIntent && !productMatchesCapIntent(idx)) { scoredProducts[si] = null; continue; }
      var title = idx.titleNorm;
      
      var levelScore = 0;
      
      if (title.indexOf(queryNorm) !== -1) {
        levelScore = 100000000;
      }
      
      if (searchGroup && idx.tagsUpper.indexOf(searchGroup) !== -1) {
        levelScore = Math.max(levelScore, 10000000);
      }
      
      var matchesType = searchTypeTerms.length > 0 && (
        capSearchIntent
          ? productMatchesCapIntent(idx)
          : searchTypeTerms.some(function(term) { return title.indexOf(term) !== -1; })
      );
      var matchesColor = searchColor && idx.tagsUpper.indexOf(searchColor) !== -1;
      
      if (matchesType && matchesColor) levelScore = Math.max(levelScore, 1000000);
      else if (matchesColor) levelScore = Math.max(levelScore, 100000);
      else if (matchesType) levelScore = Math.max(levelScore, 10000);
      
      if (queryWords.length > 0) {
        var totalFuzzy = 0;
        var matchedWords = 0;
        
        for (var qwi = 0; qwi < queryWords.length; qwi++) {
          var qWord = queryWords[qwi];
          var wordScore = bestFuzzyMatch(qWord, idx.allWords);
          if (wordScore > 0) {
            totalFuzzy += wordScore;
            matchedWords++;
          }
        }
        
        if (matchedWords > 0) {
          var allWordsMatch = matchedWords === queryWords.length;
          var avgFuzzy = totalFuzzy / queryWords.length;
          var fuzzyScore = 0;
          
          if (allWordsMatch && avgFuzzy >= 60) {
            fuzzyScore = Math.round(avgFuzzy * 100);
          } else if (allWordsMatch) {
            fuzzyScore = Math.round(avgFuzzy * 50);
          } else if (matchedWords > 0) {
            fuzzyScore = Math.round(avgFuzzy * 10 * matchedWords);
          }
          
          if (levelScore > 0) {
            levelScore += fuzzyScore;
          } else {
            levelScore = fuzzyScore;
          }
        }
      }
      
      if (levelScore > 0) {
        var salesScore = idx.salesUnits * 10;
        var stockScore = idx.hasStock ? (50 + idx.stockCount) : 0;
        scoredProducts[si] = { idx: si, score: levelScore + salesScore + stockScore };
      } else {
        scoredProducts[si] = null;
      }
    }
    
    var filtered = [];
    for (var fi = 0; fi < scoredProducts.length; fi++) {
      if (scoredProducts[fi]) filtered.push(scoredProducts[fi]);
    }
    filtered.sort(function(a, b) { return b.score - a.score; });
    
    var topResults = filtered.slice(0, TARGET_PRODUCTS);
    var finalProducts = topResults.map(function(s) { return allProductsRaw[s.idx]; });
    
    if (groupHexIndex) {
      finalProducts.forEach(function(fp) {
        var tags = [];
        if (Array.isArray(fp.tags)) tags = fp.tags;
        else if (typeof fp.tags === 'string') tags = fp.tags.split(',').map(function(t) { return t.trim(); });
        
        var gTag = '';
        for (var i = 0; i < tags.length; i++) {
          if (tags[i].toLowerCase().trim().indexOf('group_') === 0 && !gTag) gTag = tags[i].toLowerCase().trim();
        }
        if (gTag && groupHexIndex.has(gTag)) {
          var entries = groupHexIndex.get(gTag);
          fp.groupCount = entries.length;
          fp.groupHexData = entries.map(function(e) {
            return e.hex + '|||' + e.url + '|||' + e.image + '|||' + e.title + '|||' + e.priceStr + '|||' + e.compareStr + '|||' + e.priceNum + '|||' + e.compareNum;
          }).join(';;;');
        }
      });
    }
    
    var formattedProducts = formatProductsForDisplay(finalProducts);
    
    if (searchCache.size > 20) {
      var firstKey = searchCache.keys().next().value;
      searchCache.delete(firstKey);
    }
    searchCache.set(cacheKey, formattedProducts);
    
    if (myRequestId !== _searchRequestId) return;
    
    renderProgressiveProducts(formattedProducts, q, resultsInner, resultsCount, resultsCarousel, isMobile);
    
  } catch (error) {
    if (resultsInner) resultsInner.innerHTML = '<div class="search-results-message">' + T.error + '</div>';
  }
}

// ============================================================
// SECCIÓN 16: EVENT LISTENERS DE INPUT
// ============================================================

if (desktopSearchInput) {
  var debounceTimer;
  desktopSearchInput.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var query = this.value.trim();
    var desktopTrending = document.getElementById('desktopTrendingSection');
    var desktopLinks = document.getElementById('desktopLinksSection');
    var collectionsCarousel = document.getElementById('searchCollectionsCarousel');
    
    var headerBottom = calculateDesktopHeaderBottom();
    var availableHeight = window.innerHeight - headerBottom;
    
    if (query.length >= 2) {
      if (desktopTrending) desktopTrending.style.display = 'none';
      if (desktopLinks) desktopLinks.style.display = 'none';
      if (collectionsCarousel) collectionsCarousel.style.removeProperty('display');
      
      if (searchResultsCarousel) {
        searchResultsCarousel.style.cssText = getSearchPanelCSS(false, headerBottom, availableHeight);
      }
      debounceTimer = setTimeout(function() { performSearch(query, false); }, 150);
    } else {
      if (desktopTrending) desktopTrending.style.display = 'block';
      if (desktopLinks) desktopLinks.style.display = 'block';
      if (collectionsCarousel) collectionsCarousel.style.setProperty('display', 'none', 'important');
      if (searchResultsCarouselInner) searchResultsCarouselInner.innerHTML = '';
      if (searchResultsCount) searchResultsCount.textContent = '';
      
      if (searchResultsCarousel) {
        searchResultsCarousel.style.cssText = getSearchPanelCSSAuto(false, headerBottom, availableHeight);
        searchResultsCarousel.scrollTop = 0;
      }
    }
  });

  desktopSearchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); performSearch(desktopSearchInput.value.trim(), false); }
  });
}

if (mobileSearchInput) {
  var mobileDebounceTimer;
  mobileSearchInput.addEventListener('input', function() {
    clearTimeout(mobileDebounceTimer);
    var query = this.value.trim();
    var trendingSection = document.getElementById('searchTrendingSection');
    var linksSection = document.getElementById('searchLinksSection');
    var collectionsCarousel = document.getElementById('mobileSearchCollectionsCarousel');
    
    var headerBottom = calculateMobileHeaderBottom();
    var availableHeight = window.innerHeight - headerBottom;
    
    if (query.length >= 2) {
      if (trendingSection) { trendingSection.classList.remove('active'); trendingSection.style.cssText = 'display:none!important;'; }
      if (linksSection) { linksSection.classList.remove('active'); linksSection.style.cssText = 'display:none!important;'; }
      if (collectionsCarousel) collectionsCarousel.style.cssText = '';
      
      if (mobileSearchResultsCarousel) {
        mobileSearchResultsCarousel.style.cssText = getSearchPanelCSS(true, headerBottom, availableHeight);
        mobileSearchResultsCarousel.scrollTop = 0;
      }
      
      mobileDebounceTimer = setTimeout(function() { performSearch(query, true); }, 150);
    } else {
      if (trendingSection) { trendingSection.classList.add('active'); trendingSection.style.cssText = 'display:block!important;padding:18px 10px 8px 10px!important;margin:0!important;'; }
      if (linksSection) { linksSection.classList.add('active'); linksSection.style.cssText = 'display:block!important;padding:6px 10px 15px 10px!important;margin:0!important;'; }
      if (collectionsCarousel) collectionsCarousel.style.cssText = 'display:none!important;';
      
      if (mobileSearchResultsInner) mobileSearchResultsInner.innerHTML = '';
      if (mobileSearchResultsCount) mobileSearchResultsCount.textContent = '';
      
      if (mobileSearchResultsCarousel) {
        mobileSearchResultsCarousel.style.cssText = getSearchPanelCSSAuto(true, headerBottom, availableHeight);
        mobileSearchResultsCarousel.scrollTop = 0;
      }
    }
  });

  mobileSearchInput.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') { e.preventDefault(); performSearch(mobileSearchInput.value.trim(), true); }
  });
}

if (mobileSearchSubmit) {
  mobileSearchSubmit.addEventListener('click', function(e) {
    e.preventDefault();
    if (mobileSearchInput) performSearch(mobileSearchInput.value.trim(), true);
  });
}

// ============================================================
// DEBUG: helpers en window.YUXUS_SEARCH_DEBUG
// ============================================================
window.YUXUS_SEARCH_DEBUG = {
  status: function() {
    var jsonCount = (salesDataCache && salesDataCache.products) ? salesDataCache.products.length : 0;
    var shopifyCount = allProductsCache ? allProductsCache.length : 0;
    var mergedCount = _mergedDataset ? _mergedDataset.length : 0;
    var indexCount = searchIndex ? searchIndex.length : 0;
    return { currency: CURRENCY, locale: LOCALE, country: COUNTRY, rate: RATE, jsonCount: jsonCount, shopifyCount: shopifyCount, mergedCount: mergedCount, indexCount: indexCount, searchReady: searchReady, marketHandles: marketHandles ? marketHandles.size : 0 };
  },
  testPriceFormat: function(num) {
    num = parseFloat(num) || 99.95;
    return formatShopifyPrice(num);
  },
  findProduct: function(needle) {
    needle = (needle || '').toLowerCase();
    
    var inJSON = [];
    if (salesDataCache && salesDataCache.products) {
      for (var i = 0; i < salesDataCache.products.length; i++) {
        var p = salesDataCache.products[i];
        var hay = (p.title || '').toLowerCase() + ' ' + (p.handle || '').toLowerCase();
        if (hay.indexOf(needle) !== -1) inJSON.push({ title: p.title, handle: p.handle });
      }
    }
    
    var inShopify = [];
    if (allProductsCache) {
      for (var j = 0; j < allProductsCache.length; j++) {
        var sp = allProductsCache[j];
        var hay2 = (sp.title || '').toLowerCase() + ' ' + (sp.handle || '').toLowerCase();
        if (hay2.indexOf(needle) !== -1) inShopify.push({ title: sp.title, handle: sp.handle });
      }
    }
    
    var inMerged = [];
    if (_mergedDataset) {
      for (var k = 0; k < _mergedDataset.length; k++) {
        var mp = _mergedDataset[k];
        var hay3 = (mp.title || '').toLowerCase() + ' ' + (mp.handle || '').toLowerCase();
        if (hay3.indexOf(needle) !== -1) inMerged.push({ title: mp.title, handle: mp.handle });
      }
    }
    
    return { json: inJSON, shopify: inShopify, merged: inMerged };
  },
  forceLoadShopify: async function() {
    await getAllProducts();
    if (allProductsCache && allProductsCache.length > 0) {
    }
    return allProductsCache;
  },
  testFetchEndpoints: async function() {
    try {
      var r1 = await fetch('/products.json?limit=250&page=1');
      var d1 = await r1.json();
      if (d1.products && d1.products.length) {
        var hasRotary = d1.products.some(function(p) { return (p.handle || '').toLowerCase().indexOf('rotary') !== -1 || (p.title || '').toLowerCase().indexOf('rotary') !== -1; });
      }
    } catch(e) { console.error('/products.json falló:', e); }
    
    try {
      var r2 = await fetch('/collections/all/products.json?limit=250&page=1');
      var d2 = await r2.json();
    } catch(e) { console.error('/collections/all/products.json falló:', e); }
    
    try {
      var r3 = await fetch('/collections/all?view=json-products');
      var t3 = await r3.text();
      var doc3 = new DOMParser().parseFromString(t3, 'text/html');
      var s3 = doc3.querySelector('#SelectedCollectionJSON');
      console.log('?view=json-products:', s3 ? 'tiene #SelectedCollectionJSON' : 'NO tiene #SelectedCollectionJSON');
      if (s3) {
        var ps = JSON.parse(s3.textContent || '[]');
      }
    } catch(e) { console.error('?view=json-products falló:', e); }
  }
};

// ============================================================
// FIN DEL ARCHIVO
// ============================================================

});
